import CloseIcon from 'admin/common/icons/CloseIcon'
import PageWithPencile from 'admin/common/icons/PageWithPencile'
import PlusIcon from 'admin/common/icons/PlusIcon'
import RemarkMessageIcon from 'admin/common/icons/RemarkMessageIcon'
import RightArrow from 'admin/common/icons/right-arrow'
import SaveButtonIcon from 'admin/common/icons/SaveButtonIcon'
import TableLoader from 'admin/common/TableLoader'
import Barcode from 'admin/common/icons/Barcode'
import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Link, useLocation, useNavigate, useParams } from 'react-router-dom'
import Select, { components } from 'react-select';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { formatDate } from 'components/common/helpers/formatDate';
import EditIcon from 'admin/common/icons/EditIcon'
import Calendar from 'admin/common/icons/sidebar/Calendar'
import ZoneRemarkSidebarPopup from './ZoneRemarkSidebarPopup.js'
import AddInventoryComponent from './AddInventory.js'
import ZoneSidebarPopup from './ZoneSidebarPopup.js'
import ZoneModal from './ZoneModal'
import ZoneIssueChangesModal from './ZoneIssueChangesModal'
import ZoneIssueHistoryIcon from './ZoneIssueHistoryIcon'
import DeleteIcon from 'admin/common/icons/DeleteIcon'
import Apiauth from 'API/Apiauth'
import { error, loading, Updateloading } from 'components/common/helpers/toastify';
import SearchIcon from 'admin/common/icons/SearchIcon';
import { store } from '../../source/index'
import zoneGridViewIcon from '../../assets/images/zonegridview.svg'
import zoneTableViewIcon from '../../assets/images/zonetablerview.svg'
import inboxInIcon from '../../assets/images/inbox-in.svg'
import inboxOutIcon from '../../assets/images/inbox-out.svg'
import zoneEmptyIconSvg from '../../assets/images/zoneemptyiconsvg.svg'
import ZoneChatWidget from './ZoneChatWidget'
import ZoneAiSuggestionsToast from './ZoneAiSuggestionsToast'
import ZoneInventoryAlertToast from './ZoneInventoryAlertToast'
import { shouldShowIssueShortageAlert } from './zoneIssueShortageUtils'
import {
  applyReturnEqualToIssue,
  buildAiSuggestionMessage,
  hasAiSuggestions,
  shouldShowAiSuggestionToast,
  incrementReturnOnUnmatchedRow,
  isActiveUnmatchedIssueRow,
  markRowRefillSoldStatus,
  applyReturnSearchUpdates,
  findIssueRowForStockSearchItem,
  getIssueUnmatchedPoProductIds,
  isReissuableReturnedStockSearchItem,
  isReturnSearchEligibleIssueRow,
  isReturnedIssueRow,
  markRowsWithNewAdd,
  parseZoneQty,
} from './zoneAiSuggestionsUtils'
import { getZoneIssueSortableHeaders } from './ZoneIssueTableSortHeader'
import { getIssueRowStatusTier, sortIssueRows } from './zoneTableSortUtils'
import {
  mergeIssueRowWithStockSearch,
  buildChatDirectIssueRow,
  buildChatDirectReissueRow,
  normalizeZoneStockSearchItem,
  normalizeZoneStockSearchItems,
} from './zoneStockSearchUtils'
import {
  buildDeletedIssueChangeEntry,
  buildIssueBaselineMap,
  buildSessionIssueChangesPayload,
  collectSessionIssueChangeEvents,
  getIssueChangeEntries,
  getIssueRowChangeKey,
  getRowPoProductId,
  isRevertibleIssueChange,
  isSessionOnlyIssueRow,
  removeSessionIssueChangeRow,
  revertAllIssueChangesFromRows,
  revertIssuedRowFromRows,
  revertReturnedRowFromRows,
  revertSessionIssueChangeEvent,
  syncSessionIssuedEventQty,
} from './zoneIssueChangeUtils'
import {
  buildIssueHistoryLookup,
  getIssueHistoryForRow,
} from './zoneIssueHistoryUtils'
import {
  applyPartialIssueNow,
  getApiIssueAvailableQty,
  hasApiIssueAvailable,
  initPartialIssueFromApi,
  isPartialIssueEditable,
  prepareIssueItemsForSave,
} from './zonePartialIssueUtils'
import './ZoneCreateAndEdit.scss'

const RETURN_MODE_ISSUE_NEW_STOCK_MESSAGE = (t) =>
  t('To issue new stock IDs, please switch to Issue.', {
    defaultValue:
      'To issue new stock IDs, please switch to Issue.',
  });
const ZONE_TABLE_COLUMN_COUNT = 12;
const ZONE_SELECT_SHELL_PAD_X = 14;
const ZONE_MENU_OPTION_PAD_X = 16;
const ISSUE_GRID_STATUS_TIERS = [0, 1, 2, 3];

const buildZoneOptionIcon = (src, alt) => (
  <img src={src || ''} alt={alt || ''} />
);

const mapZoneToSelectOption = (zone) => ({
  value: zone._id,
  label: zone.zone,
  icon: buildZoneOptionIcon(
    zone?.zone_logo_img || zone?.zone_logo || '',
    zone.zone
  ),
});

const adjustMenuPortalPx = (value, delta) => {
  if (typeof value === 'number') {
    return value + delta;
  }
  if (typeof value === 'string' && value.endsWith('px')) {
    return `${parseFloat(value, 10) + delta}px`;
  }
  return value;
};

const zoneSelectMenuStyles = {
  menuPortal: (base) => ({
    ...base,
    zIndex: 9999,
    left: adjustMenuPortalPx(base.left, -ZONE_SELECT_SHELL_PAD_X),
    width: adjustMenuPortalPx(base.width, ZONE_SELECT_SHELL_PAD_X * 2),
    margin: 0,
    padding: 0,
  }),
  menu: (base) => ({
    ...base,
    width: '100%',
    minWidth: '100%',
    maxWidth: '100%',
    marginTop: 4,
    marginLeft: 0,
    padding: 0,
    borderRadius: 4,
    backgroundColor: '#FFFFFF',
    boxShadow:
      '0 41px 17px rgba(0, 0, 0, 0.01), 0 23px 14px rgba(0, 0, 0, 0.03), 0 10px 10px rgba(0, 0, 0, 0.05), 0 3px 6px rgba(0, 0, 0, 0.06), 0 0 0 rgba(0, 0, 0, 0.06)',
    overflow: 'hidden',
  }),
  menuList: (base) => ({
    ...base,
    padding: '16px 0',
  }),
};

const zoneSelectOptionStyle = (padX) => (base) => ({
  ...base,
  minHeight: 44,
  height: 44,
  padding: `0 ${padX}px`,
  backgroundColor: '#FFFFFF',
  color: '#606060',
  fontSize: 14,
  lineHeight: '20px',
  letterSpacing: '0.15px',
  fontFamily: "'Segoe UI', sans-serif",
  cursor: 'pointer',
});

const zoneSelectMenuPortalClass = (variant) => {
  const base = 'zone-create-edit__select-menu-portal';
  if (variant === 'zone') {
    return `${base} zone-create-edit__select-menu-portal--zone`;
  }
  if (variant === 'salesperson') {
    return `${base} zone-create-edit__select-menu-portal--salesperson`;
  }
  return base;
};

const zoneSelectMenuOptionPad = (variant) =>
  variant === 'default' ? ZONE_SELECT_SHELL_PAD_X : ZONE_MENU_OPTION_PAD_X;

const createZoneSelectPortalProps = (variant = 'default') => ({
  menuPortalTarget: document.body,
  styles: {
    ...zoneSelectMenuStyles,
    option: zoneSelectOptionStyle(zoneSelectMenuOptionPad(variant)),
  },
  classNames: {
    menuPortal: () => zoneSelectMenuPortalClass(variant),
  },
});

const zoneSelectPortalProps = createZoneSelectPortalProps('default');
const zoneFieldSelectPortalProps = createZoneSelectPortalProps('zone');
const salesPersonSelectPortalProps = createZoneSelectPortalProps('salesperson');

const ZONE_TABLE_IMAGE_PLACEHOLDER =
  'https://gis247.s3.us-east-2.amazonaws.com/placeholder-blank.png';

const handleProductImageError = (event) => {
  event.currentTarget.onerror = null;
  event.currentTarget.src = ZONE_TABLE_IMAGE_PLACEHOLDER;
};

const formatSoldCell = (sold) => {
  if (sold === null || sold === undefined) return 0;
  const str = String(sold).trim();
  if (str === '' || str === '-') return 0;
  const num = Number(str);
  if (!Number.isNaN(num)) return num;
  return sold;
};

const hasSoldQty = (sold) => {
  const value = formatSoldCell(sold);
  return typeof value === 'number' && value > 0;
};

const getIssueRowSoldQty = (row) => {
  if (!row) return 0;
  const formatted = formatSoldCell(row.sold ?? row.Sold);
  return typeof formatted === 'number' ? formatted : parseZoneQty(formatted);
};

const getIssueRowReturnQty = (row) => {
  if (!row) return 0;
  return parseZoneQty(row.return ?? row.Return);
};

const isIssueRowCheckboxDisabled = (row, isReadOnly) => {
  if (isReadOnly) return true;
  return getIssueRowSoldQty(row) > 0 || getIssueRowReturnQty(row) > 0;
};

const formatGridQtyDisplay = (value) => {
  if (value === null || value === undefined) return '-';
  const str = String(value).trim();
  return str === '' ? '-' : value;
};

const ISSUE_GRID_BADGE_BY_TIER = {
  0: { labelKey: 'Issue', variant: 'issue' },
  1: { labelKey: 'Return', variant: 'return' },
  2: { labelKey: 'Sold', variant: 'sold' },
};

const getIssueGridItemBadge = (row) =>
  ISSUE_GRID_BADGE_BY_TIER[getIssueRowStatusTier(row)] || null;

const ZoneIssueChangesIcon = () => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" aria-hidden>
    <path
      d="M4 5.5H16M4 10H13M4 14.5H11"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
    <circle cx="15.5" cy="14.5" r="2.5" stroke="currentColor" strokeWidth="1.5" />
    <path
      d="M14.3 13.3L12.7 11.7"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
  </svg>
);

export default function ZoneCreateAndEdit() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { state } = useLocation();
  const { viewEditIssueId } = useParams();



  // const [limit, setLimit] = useState(100);
  // const [filtername, setFiltername] = useState("");
  // const [datefilter, setDatefilter] = useState([]);
  const [datalodaer, setDatsLodaer] = useState(false);
  // const [StockIdsubmittedValue, setStockIdSubmittedValue] = useState('');

  const [showStockidSidebar, setStockidShowSidebar] = useState(false);
  const [showRemarkSidebar, setRemarkShowSidebar] = useState(false);
  const [showAddInventoryPage, setShowAddInventoryPage] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const [popupContent, setPopupContent] = useState({ header: '', subheader: '', withicon: false, type: false });
  const [selectedOption, setSelectedOption] = useState('issue');
  const [RemarksubmittedValue, setRemarkSubmittedValue] = useState('');
  const [viewEditIssueStatus, setViewEditIssueStatus] = useState(viewEditIssueId);

  // console.log(viewEditIssueId, "viewEditIssueId");



  const [zoneCaseScaneData, setZoneCaseScaneData] = useState([]);
  const [deletedIssueChanges, setDeletedIssueChanges] = useState([]);
  const [sessionIssueChanges, setSessionIssueChanges] = useState([]);
  const [issueHistoryChanges, setIssueHistoryChanges] = useState([]);
  const issueBaselineRef = useRef({});
  const partialIssueSyncTimersRef = useRef({});
  const [issueSortConfig, setIssueSortConfig] = useState({ key: null, dir: 'asc' });
  const issueChanges = useMemo(
    () =>
      getIssueChangeEntries(
        zoneCaseScaneData,
        deletedIssueChanges,
        issueBaselineRef.current
      ),
    [zoneCaseScaneData, deletedIssueChanges]
  );
  const hasIssueChanges = issueChanges.length > 0;
  const issueHistoryLookup = useMemo(
    () => buildIssueHistoryLookup(issueHistoryChanges),
    [issueHistoryChanges]
  );
  const [zones, setZones] = useState([]);
  const [salesPeople, setSalesPeople] = useState([]);
  const [LocationarrayList, setLocationarrayList] = useState([]);
  const [zoneList, setZoneList] = useState([]);
  const [selectedLocation, setSelectedLocation] = useState(null);
  const [selectedZone, setSelectedZone] = useState(null);
  const [multiSalesPersonList, setMultiSalesPersonList] = useState([]);
  const [selectedDate, setSelectedDate] = useState(new Date());
  const [isDatePickerOpen, setIsDatePickerOpen] = useState(false);
  const [refNumber, setRefNumber] = useState('');
  const [inputValue, setInputValue] = useState('');

  const [isChecked, setIsChecked] = useState(true); // Default checked
  const [poProductId, setPoProductId] = useState([]);
  const [poProductCollectionMap, setPoProductCollectionMap] = useState({});
  const [cardValueUpdate, setCardValueUpdate] = useState({ issue: 0, sold: 0, return: 0, balance: 0 });
  const [selectedRows, setSelectedRows] = useState([]);
  const [selectAllStatus, setSelectAllStatus] = useState(false);
  const [getOpenIssueStockDB, setOpenIssueStockDB] = useState([]);
  const [viewMode, setViewMode] = useState('table');
  const [aiSuggestionsData, setAiSuggestionsData] = useState(null);
  const [aiSuggestionToastDismissed, setAiSuggestionToastDismissed] = useState(false);
  const [removeUnmatchedRowIds, setRemoveUnmatchedRowIds] = useState([]);
  const [removeUnmatchedSnapshot, setRemoveUnmatchedSnapshot] = useState(null);
  const issueUnmatchedPoProductIds = useMemo(
    () => getIssueUnmatchedPoProductIds(aiSuggestionsData, zoneCaseScaneData),
    [aiSuggestionsData, zoneCaseScaneData]
  );
  const sortedZoneCaseScaneData = useMemo(
    () =>
      sortIssueRows(zoneCaseScaneData, issueSortConfig, {
        unmatchedPoProductIds: issueUnmatchedPoProductIds,
        aiSuggestions: aiSuggestionsData,
      }),
    [zoneCaseScaneData, issueSortConfig, issueUnmatchedPoProductIds, aiSuggestionsData]
  );
  const [chatHighlightedStockIds, setChatHighlightedStockIds] = useState([]);
  const [showIssueChangesModal, setShowIssueChangesModal] = useState(false);
  const [openIssueWarning, setOpenIssueWarning] = useState(null);
  const [issueShortageAlert, setIssueShortageAlert] = useState(null);
  const [issueShortageAlertDismissed, setIssueShortageAlertDismissed] =
    useState(false);
  const skipAiSuggestionsFetchRef = useRef(false);
    var date_format = store.getState()
    var OrgSettings = date_format?.app?.organisation_settings


  const handleDateChange = (date) => {
    if (date) {
      setSelectedDate(date);
    }
  };

  const handleTodayClick = () => {
    setSelectedDate(new Date());
  };

  const formatDatePlaceholder = () => {
    const fmt = OrgSettings?.date_format || 'DD/MM/YYYY';
    return fmt.replace(/[A-Z]/g, (char) => char.toLowerCase());
  };

  const ZoneDatePickerInput = React.forwardRef(({ onClick }, ref) => (
    <input
      ref={ref}
      readOnly
      type="text"
      className="zone-create-edit__datepicker-input"
      value={selectedDate ? formatDate(selectedDate) : ''}
      onClick={onClick}
      disabled={isSidebarMetaLocked}
      aria-label={t('Date')}
    />
  ));

  const getLocatioanAndZone = useCallback(
    async () => {

      try {
        const postdata = {
          hashkey: {}
        };
        let response = await Apiauth(postdata, `zone/get-locations`);
        if (response.code === 200) {
          const locationData = response.data.locations.map((location) => ({
            value: location._id,
            label: location.name,
            icon: <img src={location.image} alt={location.name} style={{ width: 20, height: 20, marginRight: 8 }} />,
          }));
          setLocationarrayList(locationData);

          const zoneData = response?.data?.zone;
          setZones(zoneData);

          const salesData = response?.data?.SalesPerson?.map((person) => ({
            value: person._id,
            label: person.name,
          }));
          setSalesPeople(salesData);

          // Auto-select values if editData is provided

        }

      } catch (err) {
        console.error(err, "API Error");
      } finally {

      }
    },
    [] // limit and currentPage as dependencies
  );

  useEffect(() => {
    getLocatioanAndZone();
  }, [getLocatioanAndZone]);




  // const createIssueStocks = useCallback(async (type) => {
  //   if (!selectedLocation?.value) { error("Kindly choose a location to store."); return; } else
  //     if (!selectedZone) { error("Kindly choose a zone."); return; }
  //   if (multiSalesPersonList?.length === 0) { error("Kindly choose a Sales Person."); return; }
  //   let GetloadingID = loading();
  //   try {
  //     const postdata = {
  //       "LocationId": selectedLocation?.value,
  //       "ZoneId": selectedZone?.value,
  //       "SalePersonIds": multiSalesPersonList?.map((item) => item?.value),
  //       "IssueDate": selectedDate,
  //       "ReturnDate": selectedDate,
  //       "Status": isChecked ? 1 : 0,
  //       "issue": cardValueUpdate?.issue,
  //       "return": cardValueUpdate?.return,
  //       "sold": cardValueUpdate?.sold,
  //       "items": zoneCaseScaneData,
  //       type: type
  //     };
  //     if (RemarksubmittedValue) {
  //       postdata.remark = RemarksubmittedValue;
  //     }
  //     if (viewEditIssueId) {
  //       postdata.id = viewEditIssueId;
  //     }
  //     let response = await Apiauth(postdata, `zone/create-issue-stocks`);
  //     if (response.code === 200) {
  //       Updateloading(t, GetloadingID, t("Successfully Issue"));
  //       navigate("/app/inventory/zone");

  //     }

  //   } catch (err) {
  //     console.error(err, "API Error");
  //   } finally {

  //   }
  // },

  const createIssueStocks = useCallback(
  async (type) => {
    if (!selectedLocation?.value) {
      error("Kindly choose a location to store.");
      return;
    }
    if (!selectedZone) {
      error("Kindly choose a zone.");
      return;
    }
    if (multiSalesPersonList?.length === 0) {
      error("Kindly choose a Sales Person.");
      return;
    }
    if (!viewEditIssueId && openIssueWarning?.message) {
      error(openIssueWarning.message);
      return;
    }

    const GetloadingID = loading();

    try {
      const postdata = {
        LocationId: selectedLocation?.value,
        ZoneId: selectedZone?.value,
        SalePersonIds: multiSalesPersonList?.map((item) => item?.value),
        IssueDate: selectedDate,
        ReturnDate: selectedDate,
        Status: isChecked ? 1 : 0,
        issue: cardValueUpdate?.issue,
        return: cardValueUpdate?.return,
        sold: cardValueUpdate?.sold,
        items: prepareIssueItemsForSave(zoneCaseScaneData),
        changes: buildSessionIssueChangesPayload(
          sessionIssueChanges,
          zoneCaseScaneData,
          issueBaselineRef.current
        ),
        type: type,
      };

      if (RemarksubmittedValue) {
        postdata.remark = RemarksubmittedValue;
      }
      if (viewEditIssueId) {
        postdata.id = viewEditIssueId;
      }

      const response = await Apiauth(postdata, "zone/create-issue-stocks");

      if (response?.code === 200) {
        Updateloading(t, GetloadingID, t("Successfully Issue"));
        navigate("/app/inventory/zone");
        return;
      }

      // Backend business/validation error (code 400 in body)
      const errMsg =
        response?.errors ||
        response?.message ||
        t("Something went wrong");

      Updateloading(t, GetloadingID, errMsg, "error");
    } catch (err) {
      console.error(err, "API Error");

      const errMsg =
        err?.response?.data?.errors ||
        err?.response?.data?.message ||
        err?.message ||
        t("Something went wrong");

      Updateloading(t, GetloadingID, errMsg, "error");
    }
  },
  [
    selectedLocation,
    selectedZone,
    multiSalesPersonList,
    selectedDate,
    isChecked,
    cardValueUpdate,
    zoneCaseScaneData,
    sessionIssueChanges,
    RemarksubmittedValue,
    viewEditIssueId,
    openIssueWarning,
    loading,
    Updateloading,
    error,
    t,
    navigate,
  ]
  );


  const calculateTotals = (data) => {
    // Initialize totals
    let totals = { issue: 0, sold: 0, return: 0, balance: 0 };

    // Loop through data and calculate totals
    data?.forEach((item) => {
      totals.issue += parseZoneQty(item.issue) || 0;
      totals.sold += item.sold !== "-" ? parseInt(item.sold, 10) || 0 : 0;
      totals.return += item.return !== "-" ? parseInt(item.return, 10) || 0 : 0;
      totals.balance += parseZoneQty(item.balance) || 0;
    });

    // Update state
    setCardValueUpdate(totals);
  };

  const syncPartialIssueSessionChange = useCallback((row) => {
    if (!row) return;
    setSessionIssueChanges((prev) => syncSessionIssuedEventQty(prev, row));
  }, []);

  const handlePartialIssueNowChange = useCallback(
    (stockId, rawValue, { commitSession = false } = {}) => {
      const stockKey = String(stockId ?? '');
      if (!stockKey) return;

      let updatedRow = null;
      setZoneCaseScaneData((prev) => {
        const next = prev.map((row) => {
          if (String(row?.stock_id ?? '') !== stockKey) {
            return row;
          }
          updatedRow = applyPartialIssueNow(row, rawValue, {
            onMaxExceeded: (max) => {
              error(t("Can't put more than {{max}}", { max, defaultValue: `Can't put more than ${max}` }));
            },
          });
          return updatedRow;
        });
        calculateTotals(next);
        return next;
      });

      if (commitSession && updatedRow) {
        syncPartialIssueSessionChange(updatedRow);
        return;
      }

      if (partialIssueSyncTimersRef.current[stockKey]) {
        clearTimeout(partialIssueSyncTimersRef.current[stockKey]);
      }

      partialIssueSyncTimersRef.current[stockKey] = setTimeout(() => {
        setZoneCaseScaneData((current) => {
          const row = current.find(
            (item) => String(item?.stock_id ?? '') === stockKey
          );
          if (row) {
            syncPartialIssueSessionChange(row);
          }
          return current;
        });
        delete partialIssueSyncTimersRef.current[stockKey];
      }, 800);
    },
    [syncPartialIssueSessionChange, t]
  );

  const handlePartialIssueNowBlur = useCallback(
    (stockId) => {
      const stockKey = String(stockId ?? '');
      if (!stockKey) return;

      if (partialIssueSyncTimersRef.current[stockKey]) {
        clearTimeout(partialIssueSyncTimersRef.current[stockKey]);
        delete partialIssueSyncTimersRef.current[stockKey];
      }

      setZoneCaseScaneData((prev) => {
        const row = prev.find((item) => String(item?.stock_id ?? '') === stockKey);
        if (!row || !isPartialIssueEditable(row)) {
          return prev;
        }

        const issueNow = String(row._issueNow ?? '').trim();
        if (issueNow !== '') {
          queueMicrotask(() => syncPartialIssueSessionChange(row));
          return prev;
        }

        const next = prev.map((item) => {
          if (String(item?.stock_id ?? '') !== stockKey) {
            return item;
          }
          return applyPartialIssueNow(item, 1);
        });
        calculateTotals(next);
        const restored = next.find(
          (item) => String(item?.stock_id ?? '') === stockKey
        );
        if (restored) {
          queueMicrotask(() => syncPartialIssueSessionChange(restored));
        }
        return next;
      });
    },
    [syncPartialIssueSessionChange]
  );

  useEffect(
    () => () => {
      Object.values(partialIssueSyncTimersRef.current).forEach((timerId) => {
        clearTimeout(timerId);
      });
    },
    []
  );

   const date_format_change = (date_format) => {
    var response
    if (date_format === 'DD/MM/YYYY') {
      response = 'dd/MM/yyyy'
    } else if (date_format === 'YYYY/MM/DD') {
      response = 'yyyy/MM/dd'
    } else if (date_format === 'MM/DD/YYYY') {
      response = 'MM/dd/yyyy'
    } else if (date_format === 'MM/YYYY/DD') {
      response = 'MM/yyyy/dd'
    }
    return response
  }
  const tableDataManagemenet = useCallback(
    (data, options = {}) => {
      const {
        prependNew = false,
        prependOnlyNew = false,
        highlightNew = false,
        markNewAdd = true,
        markNewReturn = false,
        onRowsUpdated,
      } = options;
      const previousRows = zoneCaseScaneData;

      if (!Array.isArray(data) || !data.length) {
        console.warn('No data provided or data is not an array.');
        return;
      }

      try {
        const normalizedData = normalizeZoneStockSearchItems(data);
        const isIssueBootstrapLoad =
          !markNewAdd && zoneCaseScaneData.length === 0;
        const canReissueReturnedItem = (item) =>
          isReissuableReturnedStockSearchItem(item, zoneCaseScaneData);

        let processIncoming = normalizedData;
        const zeroIssueStockIds = [];

        if (!isIssueBootstrapLoad) {
          const filteredMatchData = normalizedData
            .filter(
              (item) =>
                getOpenIssueStockDB.includes(item.stock_id) &&
                !canReissueReturnedItem(item)
            )
            ?.map((item) => item.stock_id);

          if (filteredMatchData?.length) {
            const string = filteredMatchData.join(',');
            error(
              `${string} id${filteredMatchData.length > 1 ? 's' : ''} ${filteredMatchData.length > 1 ? 'are' : 'is'} already issued`
            );
          }

          processIncoming = normalizedData.filter(
            (item) =>
              !getOpenIssueStockDB.includes(item.stock_id) ||
              canReissueReturnedItem(item)
          );

          if (!processIncoming.length) {
            return;
          }
        }
        if (markNewReturn) {
          const existingIncoming = [];
          let hasNewIncoming = false;

          processIncoming.forEach((item) => {
            const existingRow = findIssueRowForStockSearchItem(
              item,
              zoneCaseScaneData
            );
            if (!existingRow) {
              hasNewIncoming = true;
              return;
            }
            if (isReturnSearchEligibleIssueRow(existingRow)) {
              existingIncoming.push(item);
            }
          });

          if (hasNewIncoming) {
            error(RETURN_MODE_ISSUE_NEW_STOCK_MESSAGE(t));
          }

          if (!existingIncoming.length) {
            return;
          }

          processIncoming = existingIncoming;
        }

        const mergeIncomingRow = (existingRow, item) => {
          const merged = mergeIssueRowWithStockSearch(existingRow, item);
          if (markNewReturn) {
            return merged;
          }

          const isReissue = Boolean(existingRow && isReturnedIssueRow(existingRow));
          const maxAvailable = getApiIssueAvailableQty(item);
          const isAdditionalIssue = Boolean(
            markNewAdd &&
            existingRow &&
            !isReissue &&
            maxAvailable > 0
          );

          if (isReissue && !hasApiIssueAvailable(item)) {
            const stockId = String(existingRow?.stock_id ?? item?.stock_id ?? '');
            if (stockId) {
              zeroIssueStockIds.push(stockId);
            }
            return existingRow;
          }

          if (isAdditionalIssue || isReissue || (!existingRow && maxAvailable > 1)) {
            const baselineKey = getIssueRowChangeKey(existingRow);
            const baselineBalance =
              isAdditionalIssue
                ? Math.max(1, parseZoneQty(existingRow?.balance))
                : issueBaselineRef.current?.[baselineKey]?.balance ?? 0;

            return initPartialIssueFromApi(merged, item, {
              isReissue: isReissue || isAdditionalIssue,
              baselineBalance,
            });
          }

          return merged;
        };

        const didIncreaseIssue = (previousRow, nextRow) =>
          parseZoneQty(nextRow?.issue) > parseZoneQty(previousRow?.issue);

        const notifyZeroIssueStockIds = () => {
          if (!zeroIssueStockIds.length) {
            return;
          }
          const ids = [...new Set(zeroIssueStockIds)].join(', ');
          error(
            t('No quantity available to issue for {{ids}}.', {
              ids,
              defaultValue: `No quantity available to issue for ${ids}.`,
            })
          );
        };

        if (prependNew) {
          const movedOrNew = [];
          const movedStockIds = new Set();
          const inPlaceUpdates = new Map();
          const reissuedStockIds = new Set();
          const additionalIssuedStockIds = new Set();
          const existingStockIdsBefore = new Set(
            zoneCaseScaneData.map((row) => String(row?.stock_id ?? ''))
          );

          processIncoming.forEach((item) => {
            const existingRow = findIssueRowForStockSearchItem(
              item,
              zoneCaseScaneData
            );
            const stockId = String(
              item?.stock_id ?? existingRow?.stock_id ?? ''
            );
            if (!stockId || movedStockIds.has(stockId)) {
              return;
            }

            if (
              markNewReturn &&
              existingRow &&
              !isReturnSearchEligibleIssueRow(existingRow)
            ) {
              return;
            }

            if (prependOnlyNew && existingRow && !isReturnedIssueRow(existingRow)) {
              const mergedRow = mergeIncomingRow(existingRow, item);
              if (didIncreaseIssue(existingRow, mergedRow)) {
                additionalIssuedStockIds.add(stockId);
              }
              inPlaceUpdates.set(
                stockId,
                mergedRow
              );
              return;
            }

            const mergedRow = mergeIncomingRow(existingRow, item);
            if (
              existingRow &&
              isReturnedIssueRow(existingRow) &&
              didIncreaseIssue(existingRow, mergedRow)
            ) {
              reissuedStockIds.add(stockId);
            }
            movedOrNew.push(mergedRow);
            movedStockIds.add(stockId);
          });

          const rest = zoneCaseScaneData
            .filter((row) => !movedStockIds.has(String(row?.stock_id ?? '')))
            .map((row) => {
              const stockId = String(row?.stock_id ?? '');
              return inPlaceUpdates.has(stockId)
                ? inPlaceUpdates.get(stockId)
                : row;
            });
          let combined = [...movedOrNew, ...rest];
          if (markNewAdd) {
            const existingStockIds = new Set(
              zoneCaseScaneData.map((row) => String(row?.stock_id ?? ''))
            );
            const newStockIds = processIncoming
              .map((item) => String(item?.stock_id ?? ''))
              .filter((stockId) => stockId && !existingStockIds.has(stockId));
            combined = markRowsWithNewAdd(combined, [
              ...newStockIds,
              ...reissuedStockIds,
              ...additionalIssuedStockIds,
            ]);
          }
          if (markNewReturn) {
            combined = applyReturnSearchUpdates(
              combined,
              previousRows,
              processIncoming
            );
          }

          if (markNewAdd || markNewReturn) {
            setSessionIssueChanges((prev) =>
              collectSessionIssueChangeEvents(prev, previousRows, combined)
            );
          }

          setZoneCaseScaneData(combined);
          calculateTotals(combined);
          onRowsUpdated?.(combined);

          if (highlightNew) {
            const highlightIds = movedOrNew
              .map((item) => String(item?.stock_id ?? ''))
              .filter(
                (stockId) =>
                  stockId &&
                  (!prependOnlyNew ||
                    !existingStockIdsBefore.has(stockId) ||
                    reissuedStockIds.has(stockId) ||
                    additionalIssuedStockIds.has(stockId))
              );
            additionalIssuedStockIds.forEach((stockId) => {
              if (!highlightIds.includes(stockId)) {
                highlightIds.push(stockId);
              }
            });
            if (highlightIds.length) {
              setChatHighlightedStockIds((prev) => [
                ...new Set([...prev, ...highlightIds]),
              ]);
            }
          }
          notifyZeroIssueStockIds();
          return;
        }

        const existingStockIds = new Set(
          zoneCaseScaneData.map((row) => String(row?.stock_id ?? ''))
        );
        let uniqueData = [...zoneCaseScaneData];
        const reissuedStockIds = new Set();
        processIncoming.forEach((item) => {
          const stockId = String(item?.stock_id ?? '');
          if (!stockId) {
            return;
          }
          const existingIndex = uniqueData.findIndex(
            (row) => String(row?.stock_id ?? '') === stockId
          );
          if (existingIndex >= 0) {
            const existingRow = uniqueData[existingIndex];
            if (markNewReturn && !isReturnSearchEligibleIssueRow(existingRow)) {
              return;
            }
            const mergedRow = mergeIncomingRow(existingRow, item);
            if (
              isReturnedIssueRow(existingRow) &&
              didIncreaseIssue(existingRow, mergedRow)
            ) {
              reissuedStockIds.add(stockId);
            }
            uniqueData[existingIndex] = mergedRow;
      } else {
            uniqueData.push(item);
          }
        });

        if (markNewAdd) {
          const newStockIds = processIncoming
            .map((item) => String(item?.stock_id ?? ''))
            .filter((stockId) => stockId && !existingStockIds.has(stockId));
          uniqueData = markRowsWithNewAdd(uniqueData, [
            ...newStockIds,
            ...reissuedStockIds,
          ]);
        }
        if (markNewReturn) {
          uniqueData = applyReturnSearchUpdates(
            uniqueData,
            previousRows,
            processIncoming
          );
        }

        if (markNewAdd || markNewReturn) {
          setSessionIssueChanges((prev) =>
            collectSessionIssueChangeEvents(prev, previousRows, uniqueData)
          );
        }

        setZoneCaseScaneData(uniqueData);
        calculateTotals(uniqueData);
        onRowsUpdated?.(uniqueData);
        notifyZeroIssueStockIds();
      } catch (tableError) {
        console.error('Error in tableDataManagemenet:', tableError);
      }
    },
    [getOpenIssueStockDB, zoneCaseScaneData, t]
  );

  // const tableDataManagemenet = useCallback((data) => {
  //   if (data?.length) {
  //     try {
  //       UnSetdataTable("zoneEditcreate_table");
  //       // Merge current zoneCaseScaneData with the new data
  //       const combinedData = [...zoneCaseScaneData, ...data];

  //       // Create a map to track unique stock_ids
  //       const uniqueData = Array.from(
  //         new Map(combinedData.map((item) => [item.stock_id, item])).values()
  //       );

  //       // Update state and recalculate totals
  //       setZoneCaseScaneData(uniqueData);
  //       calculateTotals(uniqueData);

  //       SetdataTable("zoneEditcreate_table", 0, zonEditCreateHeader, 0, false);

  //     } catch (error) {
  //       console.error('Error tableDataManagemenet:', error);
  //     }
  //   }
  // }, [zoneCaseScaneData]);


  const applyPoProductCollectionNames = (data, collectionMap) => {
    if (!Array.isArray(data) || !collectionMap || !Object.keys(collectionMap).length) {
      return data;
    }
    return data.map((item) => {
      const productId = item?.po_product_id ?? item?.id ?? item?.product_id;
      const collectionName =
        collectionMap[productId] ??
        collectionMap[String(productId)] ??
        item?.collection_name ??
        item?.Collection_name ??
        item?.collection;
      if (!collectionName) {
        return item;
      }
      return { ...item, collection_name: collectionName };
    });
  };

  const checkIssueShortage = useCallback(
    async (draftCount) => {
      if (viewEditIssueId) return;
      if (!selectedZone?.value || !selectedLocation?.value) return;
      if (selectedOption !== 'issue') return;

      try {
        const response = await Apiauth(
          {
            zone_id: selectedZone.value,
            location_id: selectedLocation.value,
            draft_count: draftCount,
          },
          'zone/check-issue-shortage'
        );

        if (
          response?.code !== 200 ||
          !shouldShowIssueShortageAlert(response.data)
        ) {
          setIssueShortageAlert(null);
          setIssueShortageAlertDismissed(false);
          return;
        }

        setIssueShortageAlert({
          ...response.data,
          alertKey: Date.now(),
        });
        setIssueShortageAlertDismissed(false);
      } catch (err) {
        console.error(err, 'Issue shortage API Error');
      }
    },
    [
      selectedLocation?.value,
      selectedOption,
      selectedZone?.value,
      viewEditIssueId,
    ]
  );

  const buildStockSearchPostdata = useCallback(
    (overrides = {}) => {
        const postdata = {
        stock_id: [],
        search: '',
        po_product_id: [],
          location_id: selectedLocation?.value,
        type: selectedOption,
        ...overrides,
        };

      if (selectedZone?.value) {
        postdata.zone_id = selectedZone.value;
      }
        if (viewEditIssueId) {
        postdata.issue_id = viewEditIssueId;
      }

      return postdata;
    },
    [selectedLocation?.value, selectedOption, selectedZone?.value, viewEditIssueId]
  );

  const getStockSearch = useCallback(async (stockIdArrayData, Searchinputvalue) => {
    if (!selectedLocation) { error("Kindly choose a location to store."); return; } else
      // if (!selectedZone) { error("Kindly choose a zone."); return; }
      // let editData = false;
      // UnSetdataTable("zoneEditcreate_table");

      try {
        const postdata = buildStockSearchPostdata({
          stock_id: stockIdArrayData ? stockIdArrayData : [],
          search: Searchinputvalue ? Searchinputvalue : '',
          po_product_id: poProductId,
        });
        let response = await Apiauth(postdata, `zone/get-stocks-search`);
        if (response.code === 200) {
          const enrichedData = applyPoProductCollectionNames(
            response?.data,
            poProductCollectionMap
          );
          const isAddInventoryFlow = poProductId?.length > 0;
          const hasSearchText = Boolean(String(Searchinputvalue ?? '').trim());
          const hasStockIds =
            Array.isArray(stockIdArrayData) && stockIdArrayData.length > 0;
          const isSearchBarFlow =
            hasSearchText && !hasStockIds && !isAddInventoryFlow;
          const isStockIdFlow = hasStockIds && !isAddInventoryFlow;
          const isReturnFlow = selectedOption === 'return';
          const shouldPrependAndHighlight =
            !isReturnFlow &&
            (isAddInventoryFlow || isSearchBarFlow || isStockIdFlow);
          tableDataManagemenet(enrichedData, {
            prependNew: shouldPrependAndHighlight,
            prependOnlyNew: isSearchBarFlow,
            highlightNew: shouldPrependAndHighlight,
            markNewAdd: !isReturnFlow,
            markNewReturn: isReturnFlow,
            onRowsUpdated:
              isAddInventoryFlow && !viewEditIssueId
                ? (rows) => {
                    checkIssueShortage(rows.length);
                  }
                : undefined,
          });
          setInputValue("");
          setPoProductId([]);
          setPoProductCollectionMap({});
          // Updateloading(t, GetloadingID, t("Seaching  successfully"));
        }

      } catch (err) {
        console.error(err, "API Error");
      } finally {

      }
  },
    [poProductId, poProductCollectionMap, selectedLocation, selectedOption, selectedZone, tableDataManagemenet, viewEditIssueId, checkIssueShortage, buildStockSearchPostdata]
  );

  useEffect(() => {
    if (poProductId?.length > 0) {
      getStockSearch();  // If edit mode then it;s call auto  
    }
  }, [getStockSearch, poProductId]);




  // Handle location change
  const handleLocationChange = (selectedOption) => {
    setSelectedLocation(selectedOption);
    const filteredZones = zones
      .filter((zone) => zone.location_id === selectedOption.value)
      .map(mapZoneToSelectOption);
    setZoneList(filteredZones);
    setSelectedZone(null);
    setOpenIssueWarning(null);
    setIssueShortageAlert(null);
    setIssueShortageAlertDismissed(false);
  };

  useEffect(() => {
    if (viewEditIssueId) {
      setOpenIssueWarning(null);
      return undefined;
    }
    if (!selectedLocation?.value || !selectedZone?.value) {
      setOpenIssueWarning(null);
      return undefined;
    }

    let cancelled = false;

    const checkOpenIssueWarning = async () => {
      try {
        const response = await Apiauth(
          {
            location_id: selectedLocation.value,
            zone_id: selectedZone.value,
          },
          'zone/check-open-issue-warning'
        );

        if (cancelled) return;

        if (response?.code === 200 && response?.warning) {
          setOpenIssueWarning({
            message:
              response.message ||
              t('You cannot add new issue in this zone. An issue is already open.', {
                defaultValue:
                  'You cannot add new issue in this zone. An issue is already open.',
              }),
            data: response.data || null,
          });
          return;
        }

        setOpenIssueWarning(null);
      } catch (err) {
        console.error(err, 'Open issue warning API Error');
        if (!cancelled) {
          setOpenIssueWarning(null);
        }
      }
    };

    checkOpenIssueWarning();

    return () => {
      cancelled = true;
    };
  }, [viewEditIssueId, selectedLocation?.value, selectedZone?.value, t]);

  const handleTypeCardSelect = (type) => {
    if (type === 'return' && !viewEditIssueId) return;
    setSelectedOption(type);
  };

  const getPageMode = () => {
    if (!viewEditIssueId) return 'create';
    if (!isChecked) return 'closed';
    if (viewEditIssueStatus) return 'view';
    return 'edit';
  };

  const pageMode = getPageMode();
  const isCreateIssueFlow = !viewEditIssueId;
  const isIssueEditingActive =
    (isCreateIssueFlow && selectedOption === 'issue') ||
    (Boolean(viewEditIssueId) && !viewEditIssueStatus && isChecked);
  const showIssueChatUi =
    Boolean(selectedLocation?.value && selectedZone?.value) &&
    selectedOption === 'issue' &&
    (isCreateIssueFlow || isChecked);
  const activeIssueShortageAlert =
    issueShortageAlert && shouldShowIssueShortageAlert(issueShortageAlert)
      ? issueShortageAlert
      : null;
  const showIssueShortageToast =
    Boolean(activeIssueShortageAlert) && !issueShortageAlertDismissed;
  const isReadOnlyPanel = pageMode === 'view' || pageMode === 'closed';
  const isSidebarMetaLocked = pageMode === 'edit' || isReadOnlyPanel;
  const isSalesPersonFieldEditable = pageMode === 'create';

  const isRowRemovingUnmatched = useCallback(
    (row) => removeUnmatchedRowIds.includes(String(row?.id ?? '')),
    [removeUnmatchedRowIds]
  );

  const isRowUnmatched = useCallback(
    (row) =>
      Boolean(aiSuggestionsData) &&
      isActiveUnmatchedIssueRow(row, aiSuggestionsData) &&
      !isRowRemovingUnmatched(row),
    [aiSuggestionsData, isRowRemovingUnmatched]
  );

  const sortedNewAddIssueRows = useMemo(
    () =>
      sortedZoneCaseScaneData.filter(
        (row) => row?.new_add && !isRowUnmatched(row)
      ),
    [isRowUnmatched, sortedZoneCaseScaneData]
  );

  const sortedUnmatchedIssueRows = useMemo(
    () => sortedZoneCaseScaneData.filter((row) => isRowUnmatched(row)),
    [isRowUnmatched, sortedZoneCaseScaneData]
  );

  const sortedMatchedIssueRows = useMemo(
    () =>
      sortedZoneCaseScaneData.filter(
        (row) => !isRowUnmatched(row) && !row?.new_add
      ),
    [isRowUnmatched, sortedZoneCaseScaneData]
  );

  const issueGridSections = useMemo(() => {
    const sections = [];

    if (sortedNewAddIssueRows.length) {
      sections.push({
        key: 'new-add',
        className:
          'zone-create-edit__product-grid zone-create-edit__product-grid--new-add',
        rows: sortedNewAddIssueRows,
      });
    }

    if (sortedUnmatchedIssueRows.length) {
      sections.push({
        key: 'unmatched',
        className:
          'zone-create-edit__product-grid zone-create-edit__product-grid--unmatched',
        rows: sortedUnmatchedIssueRows,
      });
    }

    ISSUE_GRID_STATUS_TIERS.forEach((tier) => {
      const tierRows = sortedMatchedIssueRows.filter(
        (row) => getIssueRowStatusTier(row) === tier
      );
      if (!tierRows.length) {
        return;
      }

      sections.push({
        key: `tier-${tier}`,
        className: `zone-create-edit__product-grid zone-create-edit__product-grid--tier-${tier}`,
        rows: tierRows,
      });
    });

    return sections;
  }, [
    sortedMatchedIssueRows,
    sortedNewAddIssueRows,
    sortedUnmatchedIssueRows,
  ]);

  const isRowChatHighlighted = useCallback(
    (row) => chatHighlightedStockIds.includes(String(row?.stock_id ?? '')),
    [chatHighlightedStockIds]
  );

  const handleStartRemoveUnmatched = useCallback(() => {
    if (!aiSuggestionsData || !zoneCaseScaneData?.length) return false;

    const snapshot = {};
    const skeletonIds = [];

    zoneCaseScaneData.forEach((row) => {
      if (isActiveUnmatchedIssueRow(row, aiSuggestionsData)) {
        const rowId = String(row.id);
        skeletonIds.push(rowId);
        snapshot[rowId] = {
          return: row.return,
          balance: row.balance,
          new_return: row.new_return,
          _changeSnapshot: row._changeSnapshot,
        };
      }
    });

    if (!skeletonIds.length) return false;

    setRemoveUnmatchedSnapshot(snapshot);
    setRemoveUnmatchedRowIds(skeletonIds);
    return true;
  }, [aiSuggestionsData, zoneCaseScaneData]);

  const handleCommitRemoveUnmatched = useCallback(() => {
    const previousRows = zoneCaseScaneData;
    const updated = zoneCaseScaneData.map((row) => {
      if (isActiveUnmatchedIssueRow(row, aiSuggestionsData)) {
        return applyReturnEqualToIssue(row);
      }
      return row;
    });
    setSessionIssueChanges((prev) =>
      collectSessionIssueChangeEvents(prev, previousRows, updated)
    );
    setZoneCaseScaneData(updated);
    calculateTotals(updated);
    setRemoveUnmatchedRowIds([]);
    setRemoveUnmatchedSnapshot(null);
  }, [aiSuggestionsData, zoneCaseScaneData]);

  const commitChatProductTableUpdate = useCallback(
    (rows, highlightStockIds = [], tableOptions = {}) => {
      const {
        replaceTargetId = null,
        refillSoldTargetId = null,
        newAddStockIds = [],
      } = tableOptions;
      const previousRows = zoneCaseScaneData;

      let updatedRows = rows;

      if (newAddStockIds.length) {
        updatedRows = markRowsWithNewAdd(updatedRows, newAddStockIds);
      }
      if (replaceTargetId) {
        updatedRows = incrementReturnOnUnmatchedRow(updatedRows, replaceTargetId);
      }
      if (refillSoldTargetId) {
        updatedRows = markRowRefillSoldStatus(updatedRows, refillSoldTargetId);
      }

      setSessionIssueChanges((prev) =>
        collectSessionIssueChangeEvents(prev, previousRows, updatedRows)
      );
      setZoneCaseScaneData(updatedRows);
      calculateTotals(updatedRows);
      if (highlightStockIds.length) {
        setChatHighlightedStockIds((prev) => [
          ...new Set([...prev, ...highlightStockIds.map(String)]),
        ]);
      }
      return true;
    },
    [zoneCaseScaneData]
  );

  const handleAddChatProduct = useCallback(
    async (product, options = {}) => {
      const isReplaceFlow =
        options.intent === 'replace_unmatched' ||
        options.intent === 'replace_current_item';
      const replaceTargetId = isReplaceFlow
        ? product?.replace_for_po_product_id || null
        : null;
      const refillSoldTargetId = product?.refill_for_po_product_id || null;

      if (selectedOption === 'return' && !isReplaceFlow) {
        error(RETURN_MODE_ISSUE_NEW_STOCK_MESSAGE(t));
        return false;
      }

      if (!selectedLocation) {
        error('Kindly choose a location to store.');
        return false;
      }

      const stockId = String(product?.stock_id ?? '');
      if (!stockId && !product?.id) return false;

      if (isReplaceFlow) {
        if (!replaceTargetId) {
          error('Unable to match replacement to an item in this issue.');
          return false;
        }
        const targetRow = zoneCaseScaneData.find(
          (row) => String(row?.id ?? '') === String(replaceTargetId)
        );
        if (!targetRow) {
          error('Item to replace not found in this issue.');
          return false;
        }
        const issueQty = parseZoneQty(targetRow?.issue);
        const soldQty = parseZoneQty(targetRow?.sold);
        const currentReturn = parseZoneQty(targetRow?.return);
        if (currentReturn >= issueQty - soldQty) {
          error('Return quantity is already at the maximum for this item.');
          return false;
        }
      }

      const existingRow = zoneCaseScaneData.find(
        (row) =>
          (stockId && String(row?.stock_id ?? '') === stockId) ||
          (product?.id && String(row?.id ?? '') === String(product.id))
      );

      if (existingRow?.stock_id) {
        const currentReturn = parseZoneQty(existingRow?.return);
        const highlightId = String(existingRow.stock_id);
        const rest = zoneCaseScaneData.filter(
          (row) => row.stock_id !== existingRow.stock_id
        );
        let updatedRow = existingRow;

        if (currentReturn > 0 && selectedOption === 'issue') {
          updatedRow = buildChatDirectReissueRow(existingRow);
        }

        return commitChatProductTableUpdate(
          [updatedRow, ...rest],
          [highlightId],
          {
            replaceTargetId,
            refillSoldTargetId,
            newAddStockIds: currentReturn > 0 ? [highlightId] : [],
          }
        );
      }

      if (stockId && getOpenIssueStockDB.includes(stockId)) {
        error(`${stockId} is already issued`);
        return false;
      }

      const existingStockIds = new Set(
        zoneCaseScaneData.map((row) => String(row?.stock_id ?? ''))
      );
      const existingProductIds = new Set(
        zoneCaseScaneData.map((row) => String(row?.id ?? '')).filter(Boolean)
      );

      if (stockId && existingStockIds.has(stockId)) {
        return false;
      }
      if (
        product?.id &&
        existingProductIds.has(String(product.id)) &&
        !stockId
      ) {
        return false;
      }

      const newRow = buildChatDirectIssueRow(product);
      const newStockId = String(newRow?.stock_id ?? '');
      const highlightIds = newStockId ? [newStockId] : [];

      return commitChatProductTableUpdate(
        [newRow, ...zoneCaseScaneData],
        highlightIds,
        {
          replaceTargetId,
          refillSoldTargetId,
          newAddStockIds: highlightIds,
        }
      );
    },
    [
      commitChatProductTableUpdate,
      getOpenIssueStockDB,
      selectedLocation,
      selectedOption,
      t,
      zoneCaseScaneData,
    ]
  );

  const handleUndoRemoveUnmatched = useCallback(() => {
    if (!removeUnmatchedSnapshot) {
      setRemoveUnmatchedRowIds([]);
      return;
    }
    const updated = zoneCaseScaneData.map((row) => {
      const rowId = String(row?.id ?? '');
      const snapshotRow = removeUnmatchedSnapshot[rowId];
      if (!snapshotRow) {
        return row;
      }

      const nextRow = {
        ...row,
        return: snapshotRow.return,
        balance: snapshotRow.balance,
      };

      if (snapshotRow.new_return) {
        nextRow.new_return = snapshotRow.new_return;
        nextRow._changeSnapshot = snapshotRow._changeSnapshot;
      } else {
        delete nextRow.new_return;
        delete nextRow._changeSnapshot;
      }

      return nextRow;
    });
    setZoneCaseScaneData(updated);
    calculateTotals(updated);
    setRemoveUnmatchedRowIds([]);
    setRemoveUnmatchedSnapshot(null);
  }, [removeUnmatchedSnapshot, zoneCaseScaneData]);

  useEffect(() => {
    if (!viewEditIssueId || !isChecked) {
      setAiSuggestionsData(null);
      setAiSuggestionToastDismissed(false);
      return undefined;
    }
    if (!selectedLocation?.value || !selectedZone?.value) {
      return undefined;
    }
    if (showAddInventoryPage) {
      return undefined;
    }
    if (skipAiSuggestionsFetchRef.current) {
      skipAiSuggestionsFetchRef.current = false;
      return undefined;
    }

    let cancelled = false;

    const fetchAiSuggestions = async () => {
      try {
        const response = await Apiauth(
          {
            zone_id: selectedZone.value,
            location_id: selectedLocation.value,
            issue_id: viewEditIssueId,
          },
          'zone/ai-suggestions'
        );
        if (cancelled || response?.code !== 200) return;
        const suggestionsData = response.data || null;
        const hasData = hasAiSuggestions(suggestionsData);
        setAiSuggestionsData(hasData ? suggestionsData : null);
        if (hasData) {
          setAiSuggestionToastDismissed(false);
        }
      } catch (err) {
        console.error(err, 'AI suggestions API Error');
      }
    };

    fetchAiSuggestions();
    return () => {
      cancelled = true;
    };
  }, [
    viewEditIssueId,
    isChecked,
    selectedLocation?.value,
    selectedZone?.value,
    showAddInventoryPage,
  ]);

  const aiSuggestionToastMessage =
    aiSuggestionsData &&
    !aiSuggestionToastDismissed &&
    shouldShowAiSuggestionToast(aiSuggestionsData)
      ? buildAiSuggestionMessage(
          aiSuggestionsData,
          selectedZone?.label,
          t
        )
      : '';

  const renderEmptyStateIcon = () => (
    <img
      src={zoneEmptyIconSvg}
      alt=""
      className="zone-create-edit__empty-icon"
      aria-hidden
    />
  );

  const renderHeaderActions = () => {
    if (!viewEditIssueStatus) {
      return (
        <>
          <Link
            to="/app/inventory/zone"
            className="zone-create-edit__icon-btn"
            aria-label={t('Cancel')}
          >
            <CloseIcon />
          </Link>
          <button
            type="button"
            className="zone-create-edit__icon-btn zone-create-edit__icon-btn--save"
            onClick={() => createIssueStocks(selectedOption)}
            aria-label={t('Save')}
          >
            <SaveButtonIcon color="#fff" />
          </button>
        </>
      );
    }
    if (viewEditIssueId && !isChecked) {
      return (
        <Link
          to="/app/inventory/zone"
          className="zone-create-edit__icon-btn"
          aria-label={t('Close')}
        >
          <CloseIcon />
        </Link>
      );
    }
    return (
      <button
        type="button"
        className="zone-create-edit__icon-btn zone-create-edit__icon-btn--edit"
        onClick={disableLayer}
        aria-label={t('Edit')}
      >
        <EditIcon colors="#A4A4A4" />
      </button>
    );
  };

  const renderSelectOptionLabel = (option) => (
    <div className="common-select-icon">
      {option.icon}
      <span>{option.label}</span>
    </div>
  );

  const renderZoneSelectOptionLabel = (option) => (
    <div className="zone-create-edit__select-option">
      {option.icon ? (
        <span className="zone-create-edit__select-option-icon" aria-hidden>
          {option.icon}
        </span>
      ) : null}
      <span className="zone-create-edit__select-option-label">{option.label}</span>
    </div>
  );

  const renderSalesPersonOptionLabel = (option) => (
    <span className="zone-create-edit__select-option-label">{option.label}</span>
  );

  const renderProductGridHoverInfo = (item) => (
    <div className="zone-create-edit__product-grid-hover" aria-hidden>
      <div className="zone-create-edit__product-grid-hover-panel">
        <p className="zone-create-edit__product-grid-hover-sku">
          {item?.SKU || '-'}
        </p>
        {item?.stock_id ? (
          <p className="zone-create-edit__product-grid-hover-stock">
            {item.stock_id}
          </p>
        ) : null}
        <div className="zone-create-edit__product-grid-hover-stats">
          <span className="zone-create-edit__product-grid-hover-stat zone-create-edit__product-grid-hover-stat--issue">
            <span className="zone-create-edit__product-grid-hover-stat-label">
              {t('Issue')}
            </span>
            <span className="zone-create-edit__product-grid-hover-stat-value">
              {formatGridQtyDisplay(item?.issue)}
            </span>
          </span>
          <span className="zone-create-edit__product-grid-hover-stat zone-create-edit__product-grid-hover-stat--sold">
            <span className="zone-create-edit__product-grid-hover-stat-label">
              {t('Sold')}
            </span>
            <span className="zone-create-edit__product-grid-hover-stat-value">
              {formatSoldCell(item?.sold)}
            </span>
          </span>
          <span className="zone-create-edit__product-grid-hover-stat zone-create-edit__product-grid-hover-stat--return">
            <span className="zone-create-edit__product-grid-hover-stat-label">
              {t('Return')}
            </span>
            <span className="zone-create-edit__product-grid-hover-stat-value">
              {formatGridQtyDisplay(item?.return)}
            </span>
          </span>
          <span className="zone-create-edit__product-grid-hover-stat zone-create-edit__product-grid-hover-stat--balance">
            <span className="zone-create-edit__product-grid-hover-stat-label">
              {t('Balance')}
            </span>
            <span className="zone-create-edit__product-grid-hover-stat-value">
              {formatGridQtyDisplay(item?.balance)}
            </span>
          </span>
        </div>
      </div>
    </div>
  );

  const renderIssueGridItem = (result, key, sectionKey) => {
    const rowTier = getIssueRowStatusTier(result);
    const statusBadge = getIssueGridItemBadge(result);

    return (
      <div
        key={result?.id || `${sectionKey}-${key}`}
        className={`zone-create-edit__product-grid-item${
          isRowChatHighlighted(result)
            ? ' zone-create-edit__product-grid-item--chat-added'
            : ''
        }${
          rowTier === 2 ? ' zone-create-edit__product-grid-item--sold' : ''
        }${
          isRowUnmatched(result)
            ? ' zone-create-edit__product-grid-item--unmatched'
            : ''
        }${
          isRowRemovingUnmatched(result)
            ? ' zone-create-edit__product-grid-item--skeleton'
            : ''
        }`}
      >
        <img
          src={result?.main_image || ZONE_TABLE_IMAGE_PLACEHOLDER}
          alt={result?.SKU || ''}
          onError={handleProductImageError}
        />
        {isRowChatHighlighted(result) ? (
          <span
            className="zone-create-edit__product-grid-item-overlay zone-create-edit__product-grid-item-overlay--added"
            aria-hidden
          />
        ) : null}
        {rowTier === 2 ? (
          <span
            className="zone-create-edit__product-grid-item-overlay zone-create-edit__product-grid-item-overlay--sold"
            aria-hidden
          />
        ) : null}
        {statusBadge && !isRowRemovingUnmatched(result) ? (
          <span
            className={`zone-create-edit__product-grid-item-badge zone-create-edit__product-grid-item-badge--${statusBadge.variant}`}
          >
            {t(statusBadge.labelKey)}
          </span>
        ) : null}
        {renderProductGridHoverInfo(result)}
      </div>
    );
  };

  const renderSalesPersonMultiValueRemove = (props) => {
    const { innerProps } = props;
    return (
      <div
        {...innerProps}
        className={[
          innerProps?.className,
          'zone-create-edit__sales-chip-remove',
        ]
          .filter(Boolean)
          .join(' ')}
        aria-label={t('Remove')}
      >
        <CloseIcon color="#A4A4A4" width="10" height="10" />
      </div>
    );
  };

  const createZoneSelectIndicators =
    ({ hasValue, onClear, showBarcode = true }) =>
    (indicatorProps) => {
      const isDisabled =
        indicatorProps.isDisabled || indicatorProps.selectProps?.isDisabled;
      const showClear = hasValue && onClear && !isDisabled && !isSidebarMetaLocked;

      return (
        <components.IndicatorsContainer {...indicatorProps}>
          {showBarcode ? (
            <span className="zone-create-edit__select-barcode" aria-hidden>
              <Barcode />
            </span>
          ) : null}
          {showClear ? (
            <button
              type="button"
              className="zone-create-edit__select-clear"
              onMouseDown={(event) => {
                event.preventDefault();
                event.stopPropagation();
              }}
              onClick={(event) => {
                event.preventDefault();
                event.stopPropagation();
                onClear();
              }}
              aria-label={t('Clear')}
            >
              <CloseIcon color="#A4A4A4" width="14" height="14" />
            </button>
          ) : null}
          {indicatorProps.children}
        </components.IndicatorsContainer>
      );
    };

  const resetIssueShortageAlert = () => {
    setIssueShortageAlert(null);
    setIssueShortageAlertDismissed(false);
  };

  const handleClearLocation = () => {
    setSelectedLocation(null);
    setZoneList([]);
    setSelectedZone(null);
    setOpenIssueWarning(null);
    resetIssueShortageAlert();
  };

  const handleClearZone = () => {
    setSelectedZone(null);
    setOpenIssueWarning(null);
    resetIssueShortageAlert();
  };

  const handleZoneChange = (zoneOption) => {
    setSelectedZone(zoneOption);
    resetIssueShortageAlert();
  };

  const handleClearSalesPerson = () => {
    setMultiSalesPersonList([]);
  };

  const handleStockIdTextareaSubmit = (stiockidString) => {
    setStockidShowSidebar(false);
    if (stiockidString) {
      const numbersArray = stiockidString.split(/\s+/)
      if (numbersArray?.length) {
        getStockSearch(numbersArray, "");
      } else {
        error("Somthing Went Wrong");
      }
    }
  };
  const handleRemarkTextareaSubmit = (value) => {
    setRemarkSubmittedValue(value); // Update state with value from child
    setRemarkShowSidebar(false);
  };

  const searchByStockidAndSku = (event) => {
    const searchInputValue = event?.target?.value;
    if (event.type === 'change') {
      setInputValue(searchInputValue);
    }

    if (event.type === 'keydown' && event.key === 'Enter') {
      getStockSearch([], searchInputValue);
    }
  };

  const handleSearchClick = () => {
    if (inputValue) {
      getStockSearch([], inputValue);
    }
    // Perform your search or other logic here
  };

  const deleteSelectedIds = useCallback(
    async (idsToRemove) => {
      if (!idsToRemove?.length) return;

      const appendDeletedIssueChanges = (rows) => {
        if (!rows?.length) return;
        setDeletedIssueChanges((prev) => {
          const existingKeys = new Set(prev.map((entry) => entry.key));
          const next = [...prev];
          rows.forEach((row) => {
            const wasNewAdd = isSessionOnlyIssueRow(
              row,
              viewEditIssueId,
              issueBaselineRef.current
            );
            const entry = buildDeletedIssueChangeEntry(row, { wasNewAdd });
            if (!entry.key || existingKeys.has(entry.key)) return;
            existingKeys.add(entry.key);
            next.push(entry);
          });
          return next;
        });
      };

      const removeSessionChangesForRows = (rows) => {
        if (!rows?.length) return;
        setSessionIssueChanges((prev) => {
          let next = prev;
          rows.forEach((row) => {
            const changeRowId = getRowPoProductId(row) || row?.id;
            if (changeRowId) {
              next = removeSessionIssueChangeRow(next, changeRowId);
            }
          });
          return next;
        });
      };

      const blockedIds = new Set(
        (zoneCaseScaneData || [])
          .filter((item) => isIssueRowCheckboxDisabled(item, false))
          .map((item) => String(item?.id))
      );
      const allowedIds = new Set(
        idsToRemove
          .map((id) => String(id))
          .filter((id) => id && !blockedIds.has(id))
      );
      if (!allowedIds.size) return;

      const selectedRowsData = (zoneCaseScaneData || []).filter((item) =>
        allowedIds.has(String(item?.id))
      );

      const newAddRowIds = new Set();
      const deletePoProductIds = [];

      selectedRowsData.forEach((row) => {
        const rowId = String(row?.id ?? '');
        if (isSessionOnlyIssueRow(row, viewEditIssueId, issueBaselineRef.current)) {
          if (rowId) {
            newAddRowIds.add(rowId);
          }
          return;
        }

        const poProductId = getRowPoProductId(row);
        if (poProductId) {
          deletePoProductIds.push(poProductId);
        }
      });

      const persistedSelectedCount = selectedRowsData.filter(
        (row) =>
          !isSessionOnlyIssueRow(row, viewEditIssueId, issueBaselineRef.current)
      ).length;

      let updatedData = zoneCaseScaneData;
      if (newAddRowIds.size) {
        updatedData = updatedData.filter(
          (item) => !newAddRowIds.has(String(item?.id))
        );
      }

      if (persistedSelectedCount > 0 && !deletePoProductIds.length) {
        error(t('Unable to delete selected items. Product id is missing.'));
        if (newAddRowIds.size) {
          const removedSessionRows = selectedRowsData.filter((row) =>
            newAddRowIds.has(String(row?.id ?? ''))
          );
          appendDeletedIssueChanges(removedSessionRows);
          removeSessionChangesForRows(removedSessionRows);
      setZoneCaseScaneData(updatedData);
      calculateTotals(updatedData);
        }
        setSelectedRows([]);
        setSelectAllStatus(false);
        return;
      }

      if (deletePoProductIds.length && viewEditIssueId) {
        let GetloadingID;
        try {
          GetloadingID = loading();
          const apiRes = await Apiauth(
            {
              id: viewEditIssueId,
              delete_po_product_ids: deletePoProductIds,
            },
            'zone/edit-issue-stocks'
          );

          if (apiRes?.code !== 200) {
            Updateloading(t, GetloadingID, t('Failed to delete items'));
            if (newAddRowIds.size) {
              const removedSessionRows = selectedRowsData.filter((row) =>
                newAddRowIds.has(String(row?.id ?? ''))
              );
              appendDeletedIssueChanges(removedSessionRows);
              removeSessionChangesForRows(removedSessionRows);
              setZoneCaseScaneData(updatedData);
              calculateTotals(updatedData);
              setSelectedRows([]);
              setSelectAllStatus(false);
            }
            return;
          }

          Updateloading(t, GetloadingID, t('Delete item successfully'));

          const deletedPoProductIdSet = new Set(deletePoProductIds);
          updatedData = updatedData.filter((item) => {
            const poProductId = getRowPoProductId(item);
            return !poProductId || !deletedPoProductIdSet.has(poProductId);
          });
        } catch (err) {
          console.error('Error during delete API call:', err);
          if (GetloadingID) {
            Updateloading(t, GetloadingID, t('Failed to delete items'));
          }
          if (newAddRowIds.size) {
            const removedSessionRows = selectedRowsData.filter((row) =>
              newAddRowIds.has(String(row?.id ?? ''))
            );
            appendDeletedIssueChanges(removedSessionRows);
            removeSessionChangesForRows(removedSessionRows);
            setZoneCaseScaneData(updatedData);
            calculateTotals(updatedData);
            setSelectedRows([]);
            setSelectAllStatus(false);
          }
          return;
        }
      }

      appendDeletedIssueChanges(selectedRowsData);
      if (newAddRowIds.size) {
        removeSessionChangesForRows(
          selectedRowsData.filter((row) =>
            newAddRowIds.has(String(row?.id ?? ''))
          )
        );
      }

      const removedStockIds = selectedRowsData
        .map((row) => String(row?.stock_id ?? ''))
        .filter(Boolean);

      setZoneCaseScaneData(updatedData);
      calculateTotals(updatedData);
      if (removedStockIds.length) {
        setChatHighlightedStockIds((prev) =>
          prev.filter((stockId) => !removedStockIds.includes(String(stockId)))
        );
      }
      setSelectedRows([]);
      setSelectAllStatus(false);
    },
    [zoneCaseScaneData, viewEditIssueId, t]
  );
  const ZoneCaseStatusChange = (e) => {
    if (!e.target.checked) {
      setPopupContent({
        header: t('Close this issue?', { defaultValue: 'Close this issue?' }),
        subheader: t("You're going to change status from Open to Closed", {
          defaultValue: "You're going to change status from Open to Closed",
        }),
        subline2: t("This action can't be undone.", {
          defaultValue: "This action can't be undone.",
        }),
        withicon: false,
        type: false,
        confirmLabel: t('Confirm', { defaultValue: 'Confirm' }),
      });
      setOpenModal(true);
    }
  };

  const ZoneCaseStatusConfirm = async (type) => {
    setOpenModal(false);
    if (type) {
      await deleteSelectedIds(selectedRows);
    } else {
      if (viewEditIssueId) {
        let GetloadingID = loading();
        setIsChecked(false);

        try {
          const postdata = { id: viewEditIssueId, Status: 0 }
          let apiRes = await Apiauth(postdata, `zone/edit-issue-stocks`);
          if (apiRes.code === 200) {
            Updateloading(t, GetloadingID, t("Status updated successfully"));
          } else {
            console.error('Failed to update status');
          }
        } catch (error) {
          console.error('Error during API call:', error);
        } finally {
        }
      }
    }
  };


  const handleAddinventory = () => {
    if (!selectedLocation) { error("Kindly choose a location to store."); return false; }
    setShowAddInventoryPage(true);
  };

  const handleDismissIssueShortageAlert = () => {
    setIssueShortageAlertDismissed(true);
  };

  const handleIssueShortageYes = () => {
    setIssueShortageAlertDismissed(true);
  };

  const handleIssueShortageNo = () => {
    setIssueShortageAlertDismissed(true);
  };

  const handleBackToParent = () => {
    skipAiSuggestionsFetchRef.current = true;
    setShowAddInventoryPage(false);
  };
  const disableLayer = () => {
    setViewEditIssueStatus(false);

  };



  const preSelectionValue = useCallback((data) => {
    if (viewEditIssueId) {
      const selectedLoc = LocationarrayList.find((loc) => loc.value === data.LocationId);
      const filteredZones = zones
        .filter((zone) => zone.location_id === data.LocationId)
        .map(mapZoneToSelectOption);
      const selectedZn = filteredZones.find((zone) => zone.value === data.ZoneId);
      const selectedSales = salesPeople.filter((sp) => data.SalePersonIds?.includes(sp.value));

      setSelectedLocation(selectedLoc);
      setZoneList(filteredZones);
      setSelectedZone(selectedZn);
      setMultiSalesPersonList(selectedSales);
      setRefNumber(data.RefNo);
      const issueDate = data.IssueDate ? new Date(data.IssueDate) : new Date();
      setSelectedDate(issueDate);
      setSelectedOption(data?.type ?? "issue");
      setRemarkSubmittedValue(data?.remark);
      setIsChecked(data?.Status)
    }

  },
    [LocationarrayList, salesPeople, viewEditIssueId, zones]
  );

  const getIssueStockList = useCallback(
    async () => {
      setDatsLodaer(true);



      try {
        const postdata = { id: viewEditIssueId };
        let response = await Apiauth(postdata, `zone/view-issue-stocks`);
        if (response.code === 200) {
          preSelectionValue(response?.data);
          setIssueHistoryChanges(response?.data?.changes || []);
          issueBaselineRef.current = buildIssueBaselineMap(
            normalizeZoneStockSearchItems(response?.data?.items || [])
          );
          setDeletedIssueChanges([]);
          setSessionIssueChanges([]);
          tableDataManagemenet(response?.data?.items, { markNewAdd: false });
        }

      } catch (err) {
        console.error(err, "API Error");
      } finally {
        setDatsLodaer(false);
      }
    },
    [preSelectionValue, tableDataManagemenet, viewEditIssueId]
  );

  useEffect(() => {
    if (viewEditIssueId && LocationarrayList.length > 0) {
      getIssueStockList();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [viewEditIssueId, LocationarrayList]);



  const handleChangeCheckbox = (event, row) => {
    const rowId = String(event.target.value);
    const isDisabled = isIssueRowCheckboxDisabled(row, isReadOnlyPanel);

    if (isDisabled) {
      event.preventDefault();
      event.target.checked = false;
      return;
    }

    if (event.target.checked) {
      setSelectedRows((prev) =>
        prev.includes(rowId) ? prev : [...prev, rowId]
      );
    } else {
      setSelectAllStatus(false);
      setSelectedRows((prev) => prev.filter((element) => element !== rowId));
    }
  };
  useEffect(() => {
    if (!selectAllStatus) {
      setSelectedRows([]);
      return;
    }
    const ids = (zoneCaseScaneData || [])
      .filter((item) => !isIssueRowCheckboxDisabled(item, false))
      .map((item) => String(item?.id))
      .filter(Boolean);
    setSelectedRows(ids);
  }, [selectAllStatus, zoneCaseScaneData]);

  useEffect(() => {
    setSelectedRows((prev) => {
      if (!prev.length) return prev;
      const selectableIds = new Set(
        (zoneCaseScaneData || [])
          .filter((item) => !isIssueRowCheckboxDisabled(item, false))
          .map((item) => String(item?.id))
          .filter(Boolean)
      );
      const next = prev.filter((id) => selectableIds.has(String(id)));
      return next.length === prev.length ? prev : next;
    });
  }, [zoneCaseScaneData]);




  useEffect(() => {
    const fetchOpenIssueStocks = async () => {
      try {
        const postdata = { id: viewEditIssueId };
        let response = await Apiauth(postdata, `zone/get-open-issue-stocks`);
        if (response.code === 200) {
          setOpenIssueStockDB(response.data);
        }
      } catch (err) {
        console.error(err, "API Error");
      }
    };

    fetchOpenIssueStocks();
  }, [viewEditIssueId]);

  const toggleViewMode = () => {
    setViewMode((mode) => (mode === 'table' ? 'grid' : 'table'));
  };

  const handleRevertAllIssueChanges = useCallback(() => {
    const revertibleChanges = issueChanges.filter(isRevertibleIssueChange);
    if (!revertibleChanges.length) return;

    const updated = revertAllIssueChangesFromRows(
      zoneCaseScaneData,
      issueBaselineRef.current
    );

    const revertedRowIds = new Set(
      revertibleChanges.map((change) => String(change.rowId)).filter(Boolean)
    );
    const revertedStockIds = new Set(
      revertibleChanges
        .map((change) => String(change.stockId))
        .filter((stockId) => stockId && stockId !== '-')
    );

    revertedStockIds.forEach((stockId) => {
      if (partialIssueSyncTimersRef.current[stockId]) {
        clearTimeout(partialIssueSyncTimersRef.current[stockId]);
        delete partialIssueSyncTimersRef.current[stockId];
      }
    });

    setSelectedRows((prev) =>
      prev.filter((id) => !revertedRowIds.has(String(id)))
    );
    if (revertedStockIds.size) {
      setChatHighlightedStockIds((prev) =>
        prev.filter((stockId) => !revertedStockIds.has(String(stockId)))
      );
    }

    setZoneCaseScaneData(updated);
    calculateTotals(updated);
    setSessionIssueChanges((prev) => {
      let next = prev;
      revertibleChanges.forEach((change) => {
        const rowId = change?.rowId;
        const changeType = change?.type || change?.types?.[0];
        if (!rowId || !changeType) return;
        if (changeType === 'issued' && change.isNewRow) {
          next = removeSessionIssueChangeRow(next, rowId);
        } else if (changeType === 'issued') {
          next = revertSessionIssueChangeEvent(next, rowId, 'issued');
        } else if (changeType === 'returned') {
          next = revertSessionIssueChangeEvent(next, rowId, 'returned');
        }
      });
      return next;
    });
  }, [zoneCaseScaneData, issueChanges]);

  const handleRevertIssueChange = useCallback(
    (change) => {
      if (!change?.key) return;

      const stockKey =
        change.stockId && change.stockId !== '-'
          ? String(change.stockId)
          : String(change.key ?? '');
      if (stockKey && partialIssueSyncTimersRef.current[stockKey]) {
        clearTimeout(partialIssueSyncTimersRef.current[stockKey]);
        delete partialIssueSyncTimersRef.current[stockKey];
      }

      let updated = zoneCaseScaneData;
      if (change.type === 'issued') {
        updated = revertIssuedRowFromRows(
          zoneCaseScaneData,
          change.key,
          issueBaselineRef.current
        );
        setSelectedRows((prev) =>
          prev.filter((id) => String(id) !== String(change.rowId))
        );
        if (change.stockId && change.stockId !== '-') {
          setChatHighlightedStockIds((prev) =>
            prev.filter(
              (stockId) => String(stockId) !== String(change.stockId)
            )
          );
        }
      } else {
        updated = revertReturnedRowFromRows(
          zoneCaseScaneData,
          change.key,
          issueBaselineRef.current
        );
      }

      setZoneCaseScaneData(updated);
      calculateTotals(updated);
      const rowId = change?.rowId;
      if (rowId) {
        setSessionIssueChanges((prev) => {
          if (change.type === 'issued' && change.isNewRow) {
            return removeSessionIssueChangeRow(prev, rowId);
          }
          return revertSessionIssueChangeEvent(
            prev,
            rowId,
            change.type === 'issued' ? 'issued' : 'returned'
          );
        });
      }
    },
    [zoneCaseScaneData]
  );

  const renderZoneCalendarContainer = ({ className, children }) => (
    <div className={`zone-create-edit__datepicker-dropdown ${className || ''}`}>
      <div className="zone-create-edit__datepicker-dropdown-header">
        <div className="zone-create-edit__datepicker-range-field zone-create-edit__datepicker-range-field--single">
          <span className="zone-create-edit__datepicker-range-field-icon" aria-hidden>
            <Calendar width={18} height={18} color="#A4A4A4" />
                  </span>
          <span className="zone-create-edit__datepicker-range-field-value">
            {selectedDate ? formatDate(selectedDate) : formatDatePlaceholder()}
                  </span>
                    </div>
                </div>
      <div className="zone-create-edit__datepicker-dropdown-body">{children}</div>
              </div>
  );

  const renderZoneDatePickerHeader = ({
    date,
    decreaseMonth,
    increaseMonth,
    prevMonthButtonDisabled,
    nextMonthButtonDisabled,
  }) => (
    <div className="zone-create-edit__datepicker-nav">
      <div className="zone-create-edit__datepicker-nav-center">
        <button
          type="button"
          className="zone-create-edit__datepicker-nav-btn"
          onClick={decreaseMonth}
          disabled={prevMonthButtonDisabled}
          aria-label={t('Previous month')}
        >
          <span className="zone-create-edit__datepicker-nav-chevron zone-create-edit__datepicker-nav-chevron--left" />
        </button>
        <span className="zone-create-edit__datepicker-nav-label">
          {date.toLocaleString('default', { month: 'long' })}{' '}
          {date.getFullYear()}
        </span>
        <button
          type="button"
          className="zone-create-edit__datepicker-nav-btn"
          onClick={increaseMonth}
          disabled={nextMonthButtonDisabled}
          aria-label={t('Next month')}
        >
          <span className="zone-create-edit__datepicker-nav-chevron zone-create-edit__datepicker-nav-chevron--right" />
        </button>
                  </div>
      <button
        type="button"
        className="zone-create-edit__datepicker-today-btn"
        onClick={handleTodayClick}
      >
        {t('Today')}
      </button>
                  </div>
  );

  const handleIssueSort = (key) => {
    setIssueSortConfig((prev) => {
      if (prev.key === key) {
        return { key, dir: prev.dir === 'asc' ? 'desc' : 'asc' };
      }
      return { key, dir: 'asc' };
    });
  };

  return (
    <>
      {showAddInventoryPage ? (
        <AddInventoryComponent
          selectedLocation={selectedLocation?.value}
          issueId={viewEditIssueId && isChecked ? viewEditIssueId : undefined}
          setPoProductId={setPoProductId}
          setPoProductCollectionMap={setPoProductCollectionMap}
          handleBackToParent={handleBackToParent}
        />
      ) : (
        <>
        <div className={`main-body zone_module zone-create-edit zone-create-edit--${pageMode}`}>
          <div className="zone-create-edit__page-header">
            <nav className="zone-create-edit__breadcrumb" aria-label={t('Breadcrumb')}>
              <Link to="/app/inventory/myInventory">{t('Inventory')}</Link>
              <span className="zone-create-edit__breadcrumb-sep" aria-hidden>
                <RightArrow />
              </span>
              <span className="zone-create-edit__breadcrumb-current">{t('Zone')}</span>
            </nav>
            <div className="zone-create-edit__header-actions">
              {renderHeaderActions()}
                  </div>
                  </div>

          <div className="zone-create-edit__content">
            <div className="zone-create-edit__card">
              <div className="zone-create-edit__layout">
                <aside className="zone-create-edit__sidebar">
                  <h2 className="zone-create-edit__sidebar-title">
                    {viewEditIssueId ? t('Edit Issue') : t('Create Issue')}
                  </h2>

                  <div className="zone-create-edit__sidebar-body">
                    <div className="zone-create-edit__type-cards">
                      <button
                        type="button"
                        className={`zone-create-edit__type-card${
                          selectedOption === 'issue' ? ' is-active' : ''
                        }`}
                        onClick={() => handleTypeCardSelect('issue')}
                        disabled={isReadOnlyPanel}
                      >
                        <img
                          src={inboxInIcon}
                          alt=""
                          className="zone-create-edit__type-card-icon"
                          aria-hidden
                        />
                        <div className="zone-create-edit__type-card-content">
                          <span className="zone-create-edit__type-card-title">
                            {t('Issue')}
                          </span>
                          <span className="zone-create-edit__type-card-desc">
                            {t('Move items from backroom to display zone')}
                          </span>
                </div>
                        <span
                          className={`zone-create-edit__type-card-radio${
                            selectedOption === 'issue' ? ' is-checked' : ''
                          }`}
                          aria-hidden
                        />
                      </button>

                      {viewEditIssueId ? (
                        <button
                          type="button"
                          className={`zone-create-edit__type-card${
                            selectedOption === 'return' ? ' is-active' : ''
                          }`}
                          onClick={() => handleTypeCardSelect('return')}
                          disabled={isReadOnlyPanel}
                        >
                          <img
                            src={inboxOutIcon}
                            alt=""
                            className="zone-create-edit__type-card-icon"
                            aria-hidden
                          />
                          <div className="zone-create-edit__type-card-content">
                            <span className="zone-create-edit__type-card-title">
                              {t('Return')}
                            </span>
                            <span className="zone-create-edit__type-card-desc">
                              {t('Return items from display zone to backroom')}
                            </span>
                  </div>
                          <span
                            className={`zone-create-edit__type-card-radio${
                              selectedOption === 'return' ? ' is-checked' : ''
                            }`}
                            aria-hidden
                          />
                        </button>
                      ) : null}
                    </div>

                    <hr className="zone-create-edit__divider" />

                    <div className="zone-create-edit__details">
                      <h3 className="zone-create-edit__details-title">{t('Details')}</h3>

                      <div className="zone-create-edit__field">
                        <input
                          readOnly
                          className="zone-create-edit__field-input"
                          type="text"
                          value={refNumber || 'DOC-XXXX'}
                          aria-label={t('Reference number')}
                        />
                      </div>

                      <div className="zone-create-edit__field">
                        <div className="zone-create-edit__datepicker">
                          <span className="zone-create-edit__datepicker-label">
                            {t('Date')}
                          </span>
                          <div
                            className={`zone-create-edit__datepicker-plate${
                              isSidebarMetaLocked
                                ? ' zone-create-edit__datepicker-plate--locked'
                                : ''
                            }${
                              isDatePickerOpen && !isSidebarMetaLocked
                                ? ' zone-create-edit__datepicker-plate--active'
                                : ''
                            }`}
                          >
                            <div className="zone-create-edit__datepicker-content">
                              <span className="zone-create-edit__datepicker-icon">
                                <Calendar width={20} height={20} color="#A4A4A4" />
                    </span>
                    <DatePicker
                      selected={selectedDate}
                      onChange={handleDateChange}
                                customInput={<ZoneDatePickerInput />}
                                disabled={isSidebarMetaLocked}
                                onCalendarOpen={() => setIsDatePickerOpen(true)}
                                onCalendarClose={() => setIsDatePickerOpen(false)}
                      dateFormat={date_format_change(
                                  OrgSettings?.date_format
                                )}
                                calendarContainer={renderZoneCalendarContainer}
                                renderCustomHeader={renderZoneDatePickerHeader}
                                popperClassName="zone-create-edit__datepicker-popper"
                                calendarClassName="zone-create-edit__datepicker-calendar"
                                showPopperArrow={false}
                                formatWeekDay={(day) => day.slice(0, 3)}
                              />
                  </div>
                          </div>
                        </div>
                      </div>

                      <div className="zone-create-edit__field">
                        <div
                          className={`zone-create-edit__select-shell zone-create-edit__select-shell--labeled${
                            isSidebarMetaLocked
                              ? ' zone-create-edit__select-shell--locked'
                              : ''
                          }`}
                        >
                          <span className="zone-create-edit__select-shell-label">
                            {t('Location')}{' '}
                            <span className="zone-create-edit__required">*</span>
                          </span>
                    <Select
                            className="zone-create-edit__select zone-create-edit__select--ghost"
                            placeholder=""
                      options={LocationarrayList}
                      value={selectedLocation}
                      onChange={handleLocationChange}
                      classNamePrefix="common-select"
                            getOptionLabel={renderSelectOptionLabel}
                            components={{
                              IndicatorsContainer: createZoneSelectIndicators({
                                hasValue: Boolean(selectedLocation),
                                onClear: handleClearLocation,
                                showBarcode: false,
                              }),
                              ClearIndicator: () => null,
                            }}
                      isSearchable={false}
                            isDisabled={isSidebarMetaLocked}
                            {...zoneSelectPortalProps}
                    />
                        </div>
                  </div>

                      <div className="zone-create-edit__field">
                        <div
                          className={`zone-create-edit__select-shell zone-create-edit__select-shell--labeled${
                            isSidebarMetaLocked
                              ? ' zone-create-edit__select-shell--locked'
                              : ''
                          }`}
                        >
                          <span className="zone-create-edit__select-shell-label">
                            {t('Zone')}{' '}
                            <span className="zone-create-edit__required">*</span>
                          </span>
                    <Select
                            className="zone-create-edit__select zone-create-edit__select--ghost zone-create-edit__select--zone"
                            placeholder=""
                      options={zoneList}
                      value={selectedZone}
                            onChange={handleZoneChange}
                      classNamePrefix="common-select"
                            getOptionLabel={renderZoneSelectOptionLabel}
                            components={{
                              IndicatorsContainer: createZoneSelectIndicators({
                                hasValue: Boolean(selectedZone),
                                onClear: handleClearZone,
                                showBarcode: true,
                              }),
                              ClearIndicator: () => null,
                            }}
                      isSearchable={false}
                            isDisabled={isSidebarMetaLocked}
                            {...zoneFieldSelectPortalProps}
                    />
                  </div>
                        {!viewEditIssueId && openIssueWarning?.message ? (
                          <div
                            className="zone-create-edit__open-issue-warning"
                            role="alert"
                          >
                            {openIssueWarning.message}
                          </div>
                        ) : null}
                      </div>

                      <div className="zone-create-edit__field">
                        <div
                          className={`zone-create-edit__select-shell zone-create-edit__select-shell--labeled zone-create-edit__select-shell--multi zone-create-edit__select-shell--salesperson${
                            !isSalesPersonFieldEditable
                              ? ' zone-create-edit__select-shell--salesperson-readonly'
                              : ''
                          }`}
                        >
                          <span className="zone-create-edit__select-shell-label">
                            {t('Sale person')}{' '}
                            <span className="zone-create-edit__required">*</span>
                          </span>
                    <Select
                            className="zone-create-edit__select zone-create-edit__select--ghost zone-create-edit__select--sales zone-create-edit__select--salesperson"
                            placeholder=""
                      options={salesPeople}
                      value={multiSalesPersonList}
                            onChange={(value) => {
                              if (!isSalesPersonFieldEditable) return;
                              setMultiSalesPersonList(value || []);
                            }}
                            components={{
                              IndicatorsContainer: createZoneSelectIndicators({
                                hasValue: multiSalesPersonList.length > 0,
                                onClear: handleClearSalesPerson,
                                showBarcode: true,
                              }),
                              MultiValueRemove: renderSalesPersonMultiValueRemove,
                              ClearIndicator: () => null,
                            }}
                            isMulti
                            closeMenuOnSelect={false}
                            blurInputOnSelect={false}
                      classNamePrefix="common-select"
                            getOptionLabel={renderSalesPersonOptionLabel}
                      isSearchable={false}
                            isDisabled={false}
                            openMenuOnClick={isSalesPersonFieldEditable}
                            openMenuOnFocus={isSalesPersonFieldEditable}
                            {...salesPersonSelectPortalProps}
                            styles={{
                              ...salesPersonSelectPortalProps.styles,
                              control: (base) => ({
                                ...base,
                                backgroundColor: '#FFFFFF',
                                opacity: 1,
                                cursor: isSalesPersonFieldEditable
                                  ? base.cursor
                                  : 'default',
                              }),
                              valueContainer: (base) => ({
                                ...base,
                                backgroundColor: 'transparent',
                              }),
                            }}
                          />
                  </div>
                </div>
                      </div>
                      </div>
                </aside>

                <section className="zone-create-edit__main">
                  <div className="zone-create-edit__toolbar">
                    <div className="zone-create-edit__toolbar-left">
                      <div className="zone-create-edit__search">
                        <button
                          type="button"
                          className="zone-create-edit__search-icon"
                          onClick={handleSearchClick}
                          aria-label={t('Search')}
                        >
                          <SearchIcon color="#A4A4A4" />
                        </button>
                      <input
                        type="text"
                          placeholder={t('SKU or Stock ID')}
                        value={inputValue}
                        onChange={searchByStockidAndSku}
                        onKeyDown={searchByStockidAndSku}
                          disabled={isReadOnlyPanel}
                        />
                        <span className="zone-create-edit__search-icon" aria-hidden>
                          <Barcode />
                        </span>
                    </div>

                      <button
                        type="button"
                        className="zone-create-edit__btn-outline zone-create-edit__btn-inventory"
                        onClick={handleAddinventory}
                        disabled={isReadOnlyPanel}
                      >
                        <PlusIcon type="doublelayered" />
                        <span>{t('Inventory')}</span>
                      </button>

                      <button
                        type="button"
                        className="zone-create-edit__btn-outline zone-create-edit__btn-stock-id"
                        onClick={() => setStockidShowSidebar(true)}
                        disabled={isReadOnlyPanel}
                        aria-label={t('Add Stock ID')}
                      >
                      <PageWithPencile />
                      </button>
                    </div>

                    <div className="zone-create-edit__toolbar-right">
                      {selectedRows?.length ? (
                        <button
                          type="button"
                          className="zone-create-edit__toolbar-icon-btn"
                        onClick={() => {
                            setPopupContent({
                              header: 'Are you sure you want to delete this?',
                              subheader:
                                'Are you sure you want to remove this item? Yes, I want to delete it.',
                              withicon: false,
                              type: true,
                            });
                          setOpenModal(true);
                        }}
                          aria-label={t('Delete selected')}
                      >
                        <DeleteIcon type="curved" />
                        </button>
                      ) : null}

                      {!isReadOnlyPanel ? (
                        <button
                          type="button"
                          className="zone-create-edit__toolbar-icon-btn zone-create-edit__changes-btn"
                          onClick={() => setShowIssueChangesModal(true)}
                          disabled={!hasIssueChanges}
                          aria-label={t('View issue changes')}
                          title={t('View issue changes')}
                        >
                          <ZoneIssueChangesIcon />
                          {hasIssueChanges ? (
                            <span
                              className="zone-create-edit__changes-badge"
                              aria-hidden
                            >
                              {issueChanges.length}
                            </span>
                          ) : null}
                        </button>
                      ) : null}

                      <button
                        type="button"
                        className="zone-create-edit__toolbar-icon-btn zone-create-edit__view-toggle"
                        onClick={toggleViewMode}
                        aria-label={
                          viewMode === 'table'
                            ? t('Grid view')
                            : t('Table view')
                        }
                      >
                        {viewMode === 'table' ? (
                          <img
                            src={zoneGridViewIcon}
                            alt=""
                            aria-hidden
                          />
                        ) : (
                          <img
                            src={zoneTableViewIcon}
                            alt=""
                            aria-hidden
                          />
                        )}
                      </button>

                      <button
                        type="button"
                        className="zone-create-edit__toolbar-icon-btn"
                        onClick={() => setRemarkShowSidebar(true)}
                        disabled={isReadOnlyPanel}
                        aria-label={t('Remark')}
                      >
                        <RemarkMessageIcon />
                      </button>

                      <label className="zone-create-edit__status-switch">
                        <input
                          type="checkbox"
                          id="togglebtn1"
                          checked={isChecked}
                          onChange={ZoneCaseStatusChange}
                          disabled={isReadOnlyPanel}
                        />
                        <span>
                          {isChecked ? t('Status Open') : t('Status Closed')}
                        </span>
                      </label>
                    </div>
                  </div>

                  <div
                    className={`zone-create-edit__table-wrap${
                      viewMode === 'grid'
                        ? ' zone-create-edit__table-wrap--grid'
                        : ''
                    }`}
                  >
                    {viewMode === 'grid' ? (
                      issueGridSections.length ? (
                        <div className="zone-create-edit__product-grid-stack">
                          {issueGridSections.map((section) => (
                            <div
                              key={section.key}
                              className={section.className}
                            >
                              {section.rows.map((result, key) =>
                                renderIssueGridItem(result, key, section.key)
                              )}
                            </div>
                          ))}
                        </div>
                      ) : null
                    ) : (
                    <table
                      id="zoneEditcreate_table"
                      className="zone-create-edit__table"
                    >
                      <colgroup>
                        <col className="zone-create-edit__col-check" />
                        <col className="zone-create-edit__col-num" />
                        <col className="zone-create-edit__col-image" />
                        <col className="zone-create-edit__col-sku" />
                        <col className="zone-create-edit__col-data" />
                        <col className="zone-create-edit__col-data" />
                        <col className="zone-create-edit__col-data" />
                        <col className="zone-create-edit__col-data" />
                        <col className="zone-create-edit__col-summary" />
                        <col className="zone-create-edit__col-summary" />
                        <col className="zone-create-edit__col-summary" />
                        <col className="zone-create-edit__col-summary" />
                      </colgroup>
                      <thead>
                        <tr>
                          <th className="zone-create-edit__th-check">
                            <input
                              type="checkbox"
                              className="zone_createAndEdit zone-create-edit__header-checkbox"
                              checked={selectAllStatus}
                              onChange={(event) =>
                                setSelectAllStatus(event.target.checked)
                              }
                              disabled={
                                isReadOnlyPanel || !zoneCaseScaneData?.length
                              }
                              aria-label={t('Select all')}
                            />
                          </th>
                          <th className="zone-create-edit__th-num">#</th>
                          <th className="zone-create-edit__th-image">
                            {t('Image')}
                          </th>
                          {getZoneIssueSortableHeaders(t, issueSortConfig, handleIssueSort)}
                          <th className="zone-create-edit__summary-cell zone-create-edit__summary-cell--issue">
                            <span className="zone-create-edit__summary-label">
                              {t('Issue')}
                            </span>
                            <span className="zone-create-edit__summary-count">
                              {cardValueUpdate?.issue ?? 0}
                            </span>
                          </th>
                          <th className="zone-create-edit__summary-cell zone-create-edit__summary-cell--sold">
                            <span className="zone-create-edit__summary-label">
                              {t('Sold')}
                            </span>
                            <span className="zone-create-edit__summary-count">
                              {cardValueUpdate?.sold ?? 0}
                            </span>
                          </th>
                          <th className="zone-create-edit__summary-cell zone-create-edit__summary-cell--return">
                            <span className="zone-create-edit__summary-label">
                              {t('Return')}
                            </span>
                            <span className="zone-create-edit__summary-count">
                              {cardValueUpdate?.return ?? 0}
                            </span>
                          </th>
                          <th className="zone-create-edit__summary-cell zone-create-edit__summary-cell--balance">
                            <span className="zone-create-edit__summary-label">
                              {t('Balance')}
                            </span>
                            <span className="zone-create-edit__summary-count">
                              {cardValueUpdate?.balance ?? 0}
                            </span>
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {sortedZoneCaseScaneData?.length
                          ? sortedZoneCaseScaneData.map((result, key) => (
                              <tr
                                key={result?.id || key}
                                className={`zone-create-edit__body-row${
                                  isRowChatHighlighted(result)
                                    ? ' zone-create-edit__body-row--chat-added'
                                    : ''
                                }${
                                  isRowUnmatched(result)
                                    ? ' zone-create-edit__body-row--unmatched'
                                    : ''
                                }${
                                  isRowRemovingUnmatched(result)
                                    ? ' zone-create-edit__body-row--skeleton'
                                    : ''
                                }`}
                              >
                                {isRowRemovingUnmatched(result) ? (
                                  <td
                                    colSpan={ZONE_TABLE_COLUMN_COUNT}
                                    className="zone-create-edit__row-skeleton-cell"
                                  >
                                    <span
                                      className="zone-create-edit__row-skeleton"
                                      aria-hidden
                                    />
                                  </td>
                                ) : (
                                  <>
                                <td className="zone-create-edit__td-check">
                                  <div
                                    className={
                                      isIssueRowCheckboxDisabled(
                                        result,
                                        isReadOnlyPanel
                                      )
                                        ? 'com-check checkbox-disabled'
                                        : 'com-check'
                                    }
                                    onClick={(event) => {
                                      if (
                                        isIssueRowCheckboxDisabled(
                                          result,
                                          isReadOnlyPanel
                                        )
                                      ) {
                                        event.preventDefault();
                                        event.stopPropagation();
                                      }
                                    }}
                                  >
                                    <input
                                      className="inventorytablecheck inventorytableHead zone_createAndEdit"
                                      id={result?.id}
                                      data-id={result?.id}
                                      value={result?.id}
                                      type="checkbox"
                                      checked={
                                        !isIssueRowCheckboxDisabled(
                                          result,
                                          isReadOnlyPanel
                                        ) &&
                                        selectedRows.includes(String(result?.id))
                                      }
                                      onChange={(event) =>
                                        handleChangeCheckbox(event, result)
                                      }
                                      disabled={isIssueRowCheckboxDisabled(
                                        result,
                                        isReadOnlyPanel
                                      )}
                                    />
                                    <label
                                      htmlFor={
                                        isIssueRowCheckboxDisabled(
                                          result,
                                          isReadOnlyPanel
                                        )
                                          ? undefined
                                          : result?.id
                                      }
                                      className="com-check-label"
                                      aria-hidden={isIssueRowCheckboxDisabled(
                                        result,
                                        isReadOnlyPanel
                                      )}
                                    />
                                  </div>
                                </td>
                                <td className="zone-create-edit__td-num">
                                  {key + 1}
                                </td>
                                <td className="zone-create-edit__td-image table-pro-img">
                                  <img
                                    src={
                                      result?.main_image ||
                                      ZONE_TABLE_IMAGE_PLACEHOLDER
                                    }
                                    alt={result?.SKU || ''}
                                    onError={handleProductImageError}
                                  />
                                </td>
                                <td className="zone-create-edit__td-sku">
                                  {result?.SKU || '-'}
                                </td>
                                <td className="zone-create-edit__td-text">
                                  {result?.item_name || '-'}
                                </td>
                                <td className="zone-create-edit__td-text">
                                  {result?.collection_name ||
                                    result?.collection ||
                                    '-'}
                                </td>
                                <td className="zone-create-edit__td-text">
                                  {result?.size || result?.size_name || '-'}
                                </td>
                                <td className="zone-create-edit__td-text zone-create-edit__td-stock-id">
                                  <span className="zone-create-edit__stock-id-cell">
                                    <span className="zone-create-edit__stock-id-value">
                                      {result?.stock_id || '-'}
                                    </span>
                                    {(() => {
                                      const historyEvents =
                                        getIssueHistoryForRow(
                                          result,
                                          issueHistoryLookup
                                        )?.events;

                                      return (
                                        <ZoneIssueHistoryIcon
                                          key={(historyEvents || [])
                                            .map((event) => event?.type)
                                            .join('-')}
                                          events={historyEvents}
                                          t={t}
                                        />
                                      );
                                    })()}
                                  </span>
                                </td>
                                <td className="zone-create-edit__td-qty">
                                  {isPartialIssueEditable(result) &&
                                  selectedOption === 'issue' &&
                                  !isReadOnlyPanel ? (
                                    <div className="zone-create-edit__partial-issue">
                                      {parseZoneQty(result?._issueBase) > 0 ? (
                                        <>
                                          <span className="zone-create-edit__partial-issue-base">
                                            {result._issueBase}
                                          </span>
                                          <span
                                            className="zone-create-edit__partial-issue-plus"
                                            aria-hidden
                                          >
                                            +
                                          </span>
                                        </>
                                      ) : null}
                                    <input
                                        type="text"
                                        inputMode="numeric"
                                        className="zone-create-edit__qty-input zone-create-edit__qty-input--partial"
                                        value={result?._issueNow ?? ''}
                                        onChange={(event) =>
                                          handlePartialIssueNowChange(
                                            result?.stock_id,
                                            event.target.value
                                          )
                                        }
                                        onBlur={() =>
                                          handlePartialIssueNowBlur(result?.stock_id)
                                        }
                                        aria-label={t('Issue quantity')}
                                      />
                                    </div>
                                  ) : (
                                    <input
                                      type="text"
                                      readOnly
                                      tabIndex={-1}
                                      className="zone-create-edit__qty-input zone-create-edit__qty-input--readonly"
                                      value={result?.issue ?? '-'}
                                      aria-label={t('Issue quantity')}
                                    />
                                  )}
                                </td>
                                <td className="zone-create-edit__td-center">
                                  {formatSoldCell(result?.sold ?? result?.Sold)}
                                </td>
                                <td className="zone-create-edit__td-center">
                                  {formatGridQtyDisplay(
                                    result?.return ?? result?.Return
                                  )}
                                </td>
                                <td className="zone-create-edit__td-center">
                                  {result?.balance ?? '-'}
                                </td>
                                  </>
                                )}
                              </tr>
                            ))
                          : null}
                      </tbody>
                      {zoneCaseScaneData?.length ? (
                      <tfoot>
                          <tr className="zone-create-edit__footer-row">
                            <td
                              colSpan={8}
                              className="zone-create-edit__footer-label"
                            >
                              {t('Total')}
                            </td>
                            <td className="zone-create-edit__td-center zone-create-edit__footer-total">
                              {cardValueUpdate?.issue ?? 0}
                            </td>
                            <td className="zone-create-edit__td-center zone-create-edit__footer-total">
                              {cardValueUpdate?.sold ?? 0}
                            </td>
                            <td className="zone-create-edit__td-center zone-create-edit__footer-total">
                              {cardValueUpdate?.return ?? 0}
                            </td>
                            <td className="zone-create-edit__td-center zone-create-edit__footer-total">
                              {cardValueUpdate?.balance ?? 0}
                            </td>
                        </tr>
                      </tfoot>
                      ) : null}
                    </table>
                    )}

                    {!zoneCaseScaneData?.length ? (
                      <div className="zone-create-edit__empty">
                        {renderEmptyStateIcon()}
                        <p>
                          {t(
                            'Fill information on left side + Click "Issue" before adding product.'
                          )}
                        </p>
                </div>
                    ) : null}

                    {datalodaer ? <TableLoader /> : null}
              </div>
                </section>
            </div>
          </div>
        </div>
        </div>
        </>
      )}
      {showIssueChatUi ? (
        <div
          className="zone-create-edit__chat-ui"
          style={{ display: showAddInventoryPage ? 'none' : undefined }}
          aria-hidden={showAddInventoryPage}
        >
          <ZoneInventoryAlertToast
            alertData={showIssueShortageToast ? activeIssueShortageAlert : null}
            onClose={handleDismissIssueShortageAlert}
            disabled={!isIssueEditingActive}
            stackAbove={Boolean(aiSuggestionToastMessage)}
          />
          <ZoneAiSuggestionsToast
            message={aiSuggestionToastMessage}
            disabled={!isIssueEditingActive}
            onClose={() => setAiSuggestionToastDismissed(true)}
          />
          <ZoneChatWidget
            aiSuggestions={aiSuggestionsData}
            issueRows={zoneCaseScaneData}
            isEditMode={isIssueEditingActive && Boolean(viewEditIssueId)}
            isChatEnabled={isIssueEditingActive}
            zoneId={selectedZone?.value}
            locationId={selectedLocation?.value}
            issueId={viewEditIssueId && isChecked ? viewEditIssueId : undefined}
            zoneLabel={selectedZone?.label}
            hasNotification={
              Boolean(aiSuggestionToastMessage) || showIssueShortageToast
            }
            issueShortagePrompt={activeIssueShortageAlert}
            onIssueShortageYes={handleIssueShortageYes}
            onIssueShortageNo={handleIssueShortageNo}
            onStartRemoveUnmatched={handleStartRemoveUnmatched}
            onCommitRemoveUnmatched={handleCommitRemoveUnmatched}
            onUndoRemoveUnmatched={handleUndoRemoveUnmatched}
            onAddChatProduct={handleAddChatProduct}
          />
        </div>
      ) : null}
      {showStockidSidebar ? <ZoneSidebarPopup setStockidShowSidebar={setStockidShowSidebar} onSubmit={handleStockIdTextareaSubmit} /> : null}
      {showRemarkSidebar ? <ZoneRemarkSidebarPopup RemarksubmittedValue={RemarksubmittedValue} setRemarkShowSidebar={setRemarkShowSidebar} onSubmit={handleRemarkTextareaSubmit} /> : null}



      {openModal && (
        <ZoneModal
          setOpenModal={setOpenModal}
          popupContent={popupContent}
          onConfirm={ZoneCaseStatusConfirm} // Pass confirmation handler
        />
      )}
      <ZoneIssueChangesModal
        open={showIssueChangesModal}
        onClose={() => setShowIssueChangesModal(false)}
        changes={issueChanges}
        onRevert={handleRevertIssueChange}
        onRevertAll={handleRevertAllIssueChanges}
      />
    </>
  )
}
